var items = {
  "block.minecraft.acacia_button": "Akacjowy przycisk",
  "block.minecraft.acacia_door": "Akacjowe drzwi",
  "block.minecraft.acacia_fence": "Akacjowy płot",
  "block.minecraft.acacia_fence_gate": "Akacjowa furtka",
  "block.minecraft.acacia_hanging_sign": "Akacjowa podwieszana tabliczka",
  "block.minecraft.acacia_leaves": "Akacjowe liście",
  "block.minecraft.acacia_log": "Akacjowy pień",
  "block.minecraft.acacia_planks": "Akacjowe deski",
  "block.minecraft.acacia_pressure_plate": "Akacjowa płytka naciskowa",
  "block.minecraft.acacia_sapling": "Sadzonka akacji",
  "block.minecraft.acacia_shelf": "Akacjowa półka",
  "block.minecraft.acacia_sign": "Akacjowa tabliczka",
  "block.minecraft.acacia_slab": "Akacjowa płyta",
  "block.minecraft.acacia_stairs": "Akacjowe schody",
  "block.minecraft.acacia_trapdoor": "Akacjowa klapa",
  "block.minecraft.acacia_wall_hanging_sign": "Akacjowa ścienna podwieszana tabliczka",
  "block.minecraft.acacia_wall_sign": "Akacjowa ścienna tabliczka",
  "block.minecraft.acacia_wood": "Akacjowe drewno",
  "block.minecraft.activator_rail": "Tory aktywacyjne",
  "block.minecraft.air": "Powietrze",
  "block.minecraft.allium": "Czosnek",
  "block.minecraft.amethyst_block": "Blok ametystu",
  "block.minecraft.amethyst_cluster": "Skupisko ametystu",
  "block.minecraft.ancient_debris": "Pradawne zgliszcza",
  "block.minecraft.andesite": "Andezyt",
  "block.minecraft.andesite_slab": "Andezytowa płyta",
  "block.minecraft.andesite_stairs": "Andezytowe schody",
  "block.minecraft.andesite_wall": "Andezytowy murek",
  "block.minecraft.anvil": "Kowadło",
  "block.minecraft.attached_melon_stem": "Przyłączona łodyga arbuza",
  "block.minecraft.attached_pumpkin_stem": "Przyłączona łodyga dyni",
  "block.minecraft.azalea": "Azalia",
  "block.minecraft.azalea_leaves": "Azaliowe liście",
  "block.minecraft.azure_bluet": "Houstonia błękitna",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Blok bambusu",
  "block.minecraft.bamboo_button": "Bambusowy przycisk",
  "block.minecraft.bamboo_door": "Bambusowe drzwi",
  "block.minecraft.bamboo_fence": "Bambusowy płot",
  "block.minecraft.bamboo_fence_gate": "Bambusowa furtka",
  "block.minecraft.bamboo_hanging_sign": "Bambusowa podwieszana tabliczka",
  "block.minecraft.bamboo_mosaic": "Bambusowa mozaika",
  "block.minecraft.bamboo_mosaic_slab": "Bambusowa mozaikowa płyta",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusowe mozaikowe schody",
  "block.minecraft.bamboo_planks": "Bambusowe deski",
  "block.minecraft.bamboo_pressure_plate": "Bambusowa płytka naciskowa",
  "block.minecraft.bamboo_sapling": "Pęd bambusa",
  "block.minecraft.bamboo_shelf": "Bambusowa półka",
  "block.minecraft.bamboo_sign": "Bambusowa tabliczka",
  "block.minecraft.bamboo_slab": "Bambusowa płyta",
  "block.minecraft.bamboo_stairs": "Bambusowe schody",
  "block.minecraft.bamboo_trapdoor": "Bambusowa klapa",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambusowa ścienna podwieszana tabliczka",
  "block.minecraft.bamboo_wall_sign": "Bambusowa ścienna tabliczka",
  "block.minecraft.banner.base.black": "Czarne tło",
  "block.minecraft.banner.base.blue": "Niebieskie tło",
  "block.minecraft.banner.base.brown": "Brązowe tło",
  "block.minecraft.banner.base.cyan": "Błękitne tło",
  "block.minecraft.banner.base.gray": "Szare tło",
  "block.minecraft.banner.base.green": "Zielone tło",
  "block.minecraft.banner.base.light_blue": "Jasnoniebieskie tło",
  "block.minecraft.banner.base.light_gray": "Jasnoszare tło",
  "block.minecraft.banner.base.lime": "Jasnozielone tło",
  "block.minecraft.banner.base.magenta": "Purpurowe tło",
  "block.minecraft.banner.base.orange": "Pomarańczowe tło",
  "block.minecraft.banner.base.pink": "Różowe tło",
  "block.minecraft.banner.base.purple": "Fioletowe tło",
  "block.minecraft.banner.base.red": "Czerwone tło",
  "block.minecraft.banner.base.white": "Białe tło",
  "block.minecraft.banner.base.yellow": "Żółte tło",
  "block.minecraft.banner.border.black": "Czarne obramowanie",
  "block.minecraft.banner.border.blue": "Niebieskie obramowanie",
  "block.minecraft.banner.border.brown": "Brązowe obramowanie",
  "block.minecraft.banner.border.cyan": "Błękitne obramowanie",
  "block.minecraft.banner.border.gray": "Szare obramowanie",
  "block.minecraft.banner.border.green": "Zielone obramowanie",
  "block.minecraft.banner.border.light_blue": "Jasnoniebieskie obramowanie",
  "block.minecraft.banner.border.light_gray": "Jasnoszare obramowanie",
  "block.minecraft.banner.border.lime": "Jasnozielone obramowanie",
  "block.minecraft.banner.border.magenta": "Purpurowe obramowanie",
  "block.minecraft.banner.border.orange": "Pomarańczowe obramowanie",
  "block.minecraft.banner.border.pink": "Różowe obramowanie",
  "block.minecraft.banner.border.purple": "Fioletowe obramowanie",
  "block.minecraft.banner.border.red": "Czerwone obramowanie",
  "block.minecraft.banner.border.white": "Białe obramowanie",
  "block.minecraft.banner.border.yellow": "Żółte obramowanie",
  "block.minecraft.banner.bricks.black": "Czarne murowane pole",
  "block.minecraft.banner.bricks.blue": "Niebieskie murowane pole",
  "block.minecraft.banner.bricks.brown": "Brązowe murowane pole",
  "block.minecraft.banner.bricks.cyan": "Błękitne murowane pole",
  "block.minecraft.banner.bricks.gray": "Szare murowane pole",
  "block.minecraft.banner.bricks.green": "Zielone murowane pole",
  "block.minecraft.banner.bricks.light_blue": "Jasnoniebieskie murowane pole",
  "block.minecraft.banner.bricks.light_gray": "Jasnoszare murowane pole",
  "block.minecraft.banner.bricks.lime": "Jasnozielone murowane pole",
  "block.minecraft.banner.bricks.magenta": "Purpurowe murowane pole",
  "block.minecraft.banner.bricks.orange": "Pomarańczowe murowane pole",
  "block.minecraft.banner.bricks.pink": "Różowe murowane pole",
  "block.minecraft.banner.bricks.purple": "Fioletowe murowane pole",
  "block.minecraft.banner.bricks.red": "Czerwone murowane pole",
  "block.minecraft.banner.bricks.white": "Białe murowane pole",
  "block.minecraft.banner.bricks.yellow": "Żółte murowane pole",
  "block.minecraft.banner.circle.black": "Czarny krąg",
  "block.minecraft.banner.circle.blue": "Niebieski krąg",
  "block.minecraft.banner.circle.brown": "Brązowy krąg",
  "block.minecraft.banner.circle.cyan": "Błękitny krąg",
  "block.minecraft.banner.circle.gray": "Szary krąg",
  "block.minecraft.banner.circle.green": "Zielony krąg",
  "block.minecraft.banner.circle.light_blue": "Jasnoniebieski krąg",
  "block.minecraft.banner.circle.light_gray": "Jasnoszary krąg",
  "block.minecraft.banner.circle.lime": "Jasnozielony krąg",
  "block.minecraft.banner.circle.magenta": "Purpurowy krąg",
  "block.minecraft.banner.circle.orange": "Pomarańczowy krąg",
  "block.minecraft.banner.circle.pink": "Różowy krąg",
  "block.minecraft.banner.circle.purple": "Fioletowy krąg",
  "block.minecraft.banner.circle.red": "Czerwony krąg",
  "block.minecraft.banner.circle.white": "Biały krąg",
  "block.minecraft.banner.circle.yellow": "Żółty krąg",
  "block.minecraft.banner.creeper.black": "Czarny wizerunek creepera",
  "block.minecraft.banner.creeper.blue": "Niebieski wizerunek creepera",
  "block.minecraft.banner.creeper.brown": "Brązowy wizerunek creepera",
  "block.minecraft.banner.creeper.cyan": "Błękitny wizerunek creepera",
  "block.minecraft.banner.creeper.gray": "Szary wizerunek creepera",
  "block.minecraft.banner.creeper.green": "Zielony wizerunek creepera",
  "block.minecraft.banner.creeper.light_blue": "Jasnoniebieski wizerunek creepera",
  "block.minecraft.banner.creeper.light_gray": "Jasnoszary wizerunek creepera",
  "block.minecraft.banner.creeper.lime": "Jasnozielony wizerunek creepera",
  "block.minecraft.banner.creeper.magenta": "Purpurowy wizerunek creepera",
  "block.minecraft.banner.creeper.orange": "Pomarańczowy wizerunek creepera",
  "block.minecraft.banner.creeper.pink": "Różowy wizerunek creepera",
  "block.minecraft.banner.creeper.purple": "Fioletowy wizerunek creepera",
  "block.minecraft.banner.creeper.red": "Czerwony wizerunek creepera",
  "block.minecraft.banner.creeper.white": "Biały wizerunek creepera",
  "block.minecraft.banner.creeper.yellow": "Żółty wizerunek creepera",
  "block.minecraft.banner.cross.black": "Czarny skośny krzyż",
  "block.minecraft.banner.cross.blue": "Niebieski skośny krzyż",
  "block.minecraft.banner.cross.brown": "Brązowy skośny krzyż",
  "block.minecraft.banner.cross.cyan": "Błękitny skośny krzyż",
  "block.minecraft.banner.cross.gray": "Szary skośny krzyż",
  "block.minecraft.banner.cross.green": "Zielony skośny krzyż",
  "block.minecraft.banner.cross.light_blue": "Jasnoniebieski skośny krzyż",
  "block.minecraft.banner.cross.light_gray": "Jasnoszary skośny krzyż",
  "block.minecraft.banner.cross.lime": "Jasnozielony skośny krzyż",
  "block.minecraft.banner.cross.magenta": "Purpurowy skośny krzyż",
  "block.minecraft.banner.cross.orange": "Pomarańczowy skośny krzyż",
  "block.minecraft.banner.cross.pink": "Różowy skośny krzyż",
  "block.minecraft.banner.cross.purple": "Fioletowy skośny krzyż",
  "block.minecraft.banner.cross.red": "Czerwony skośny krzyż",
  "block.minecraft.banner.cross.white": "Biały skośny krzyż",
  "block.minecraft.banner.cross.yellow": "Żółty skośny krzyż",
  "block.minecraft.banner.curly_border.black": "Czarne ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.blue": "Niebieskie ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.brown": "Brązowe ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.cyan": "Błękitne ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.gray": "Szare ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.green": "Zielone ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.light_blue": "Jasnoniebieskie ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.light_gray": "Jasnoszare ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.lime": "Jasnozielone ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.magenta": "Purpurowe ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.orange": "Pomarańczowe ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.pink": "Różowe ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.purple": "Fioletowe ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.red": "Czerwone ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.white": "Białe ząbkowane obramowanie",
  "block.minecraft.banner.curly_border.yellow": "Żółte ząbkowane obramowanie",
  "block.minecraft.banner.diagonal_left.black": "Czarna skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.blue": "Niebieska skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.brown": "Brązowa skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.cyan": "Błękitna skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.gray": "Szara skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.green": "Zielona skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.light_blue": "Jasnoniebieska skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.light_gray": "Jasnoszara skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.lime": "Jasnozielona skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.magenta": "Purpurowa skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.orange": "Pomarańczowa skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.pink": "Różowa skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.purple": "Fioletowa skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.red": "Czerwona skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.white": "Biała skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_left.yellow": "Żółta skośna lewa górna połowa",
  "block.minecraft.banner.diagonal_right.black": "Czarna skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.blue": "Niebieska skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.brown": "Brązowa skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.cyan": "Błękitna skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.gray": "Szara skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.green": "Zielona skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.light_blue": "Jasnoniebieska skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.light_gray": "Jasnoszara skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.lime": "Jasnozielona skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.magenta": "Purpurowa skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.orange": "Pomarańczowa skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.pink": "Różowa skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.purple": "Fioletowa skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.red": "Czerwona skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.white": "Biała skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_right.yellow": "Żółta skośna prawa górna połowa",
  "block.minecraft.banner.diagonal_up_left.black": "Czarna skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.blue": "Niebieska skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.brown": "Brązowa skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.cyan": "Błękitna skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.gray": "Szara skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.green": "Zielona skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Jasnoniebieska skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Jasnoszara skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.lime": "Jasnozielona skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.magenta": "Purpurowa skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.orange": "Pomarańczowa skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.pink": "Różowa skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.purple": "Fioletowa skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.red": "Czerwona skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.white": "Biała skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_left.yellow": "Żółta skośna lewa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.black": "Czarna skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.blue": "Niebieska skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.brown": "Brązowa skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.cyan": "Błękitna skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.gray": "Szara skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.green": "Zielona skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Jasnoniebieska skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Jasnoszara skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.lime": "Jasnozielona skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.magenta": "Purpurowa skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.orange": "Pomarańczowa skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.pink": "Różowa skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.purple": "Fioletowa skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.red": "Czerwona skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.white": "Biała skośna prawa dolna połowa",
  "block.minecraft.banner.diagonal_up_right.yellow": "Żółta skośna prawa dolna połowa",
  "block.minecraft.banner.flow.black": "Czarny nurt",
  "block.minecraft.banner.flow.blue": "Niebieski nurt",
  "block.minecraft.banner.flow.brown": "Brązowy nurt",
  "block.minecraft.banner.flow.cyan": "Błękitny nurt",
  "block.minecraft.banner.flow.gray": "Szary nurt",
  "block.minecraft.banner.flow.green": "Zielony nurt",
  "block.minecraft.banner.flow.light_blue": "Jasnoniebieski nurt",
  "block.minecraft.banner.flow.light_gray": "Jasnoszary nurt",
  "block.minecraft.banner.flow.lime": "Jasnozielony nurt",
  "block.minecraft.banner.flow.magenta": "Purpurowy nurt",
  "block.minecraft.banner.flow.orange": "Pomarańczowy nurt",
  "block.minecraft.banner.flow.pink": "Różowy nurt",
  "block.minecraft.banner.flow.purple": "Fioletowy nurt",
  "block.minecraft.banner.flow.red": "Czerwony nurt",
  "block.minecraft.banner.flow.white": "Biały nurt",
  "block.minecraft.banner.flow.yellow": "Żółty nurt",
  "block.minecraft.banner.flower.black": "Czarny wzór kwiatu",
  "block.minecraft.banner.flower.blue": "Niebieski wzór kwiatu",
  "block.minecraft.banner.flower.brown": "Brązowy wzór kwiatu",
  "block.minecraft.banner.flower.cyan": "Błękitny wzór kwiatu",
  "block.minecraft.banner.flower.gray": "Szary wzór kwiatu",
  "block.minecraft.banner.flower.green": "Zielony wzór kwiatu",
  "block.minecraft.banner.flower.light_blue": "Jasnoniebieski wzór kwiatu",
  "block.minecraft.banner.flower.light_gray": "Jasnoszary wzór kwiatu",
  "block.minecraft.banner.flower.lime": "Jasnozielony wzór kwiatu",
  "block.minecraft.banner.flower.magenta": "Purpurowy wzór kwiatu",
  "block.minecraft.banner.flower.orange": "Pomarańczowy wzór kwiatu",
  "block.minecraft.banner.flower.pink": "Różowy wzór kwiatu",
  "block.minecraft.banner.flower.purple": "Fioletowy wzór kwiatu",
  "block.minecraft.banner.flower.red": "Czerwony wzór kwiatu",
  "block.minecraft.banner.flower.white": "Biały wzór kwiatu",
  "block.minecraft.banner.flower.yellow": "Żółty wzór kwiatu",
  "block.minecraft.banner.globe.black": "Czarny sześcian ziemski",
  "block.minecraft.banner.globe.blue": "Niebieski sześcian ziemski",
  "block.minecraft.banner.globe.brown": "Brązowy sześcian ziemski",
  "block.minecraft.banner.globe.cyan": "Błękitny sześcian ziemski",
  "block.minecraft.banner.globe.gray": "Szary sześcian ziemski",
  "block.minecraft.banner.globe.green": "Zielony sześcian ziemski",
  "block.minecraft.banner.globe.light_blue": "Jasnoniebieski sześcian ziemski",
  "block.minecraft.banner.globe.light_gray": "Jasnoszary sześcian ziemski",
  "block.minecraft.banner.globe.lime": "Jasnozielony sześcian ziemski",
  "block.minecraft.banner.globe.magenta": "Purpurowy sześcian ziemski",
  "block.minecraft.banner.globe.orange": "Pomarańczowy sześcian ziemski",
  "block.minecraft.banner.globe.pink": "Różowy sześcian ziemski",
  "block.minecraft.banner.globe.purple": "Fioletowy sześcian ziemski",
  "block.minecraft.banner.globe.red": "Czerwony sześcian ziemski",
  "block.minecraft.banner.globe.white": "Biały sześcian ziemski",
  "block.minecraft.banner.globe.yellow": "Żółty sześcian ziemski",
  "block.minecraft.banner.gradient.black": "Czarny gradient",
  "block.minecraft.banner.gradient.blue": "Niebieski gradient",
  "block.minecraft.banner.gradient.brown": "Brązowy gradient",
  "block.minecraft.banner.gradient.cyan": "Błękitny gradient",
  "block.minecraft.banner.gradient.gray": "Szary gradient",
  "block.minecraft.banner.gradient.green": "Zielony gradient",
  "block.minecraft.banner.gradient.light_blue": "Jasnoniebieski gradient",
  "block.minecraft.banner.gradient.light_gray": "Jasnoszary gradient",
  "block.minecraft.banner.gradient.lime": "Jasnozielony gradient",
  "block.minecraft.banner.gradient.magenta": "Purpurowy gradient",
  "block.minecraft.banner.gradient.orange": "Pomarańczowy gradient",
  "block.minecraft.banner.gradient.pink": "Różowy gradient",
  "block.minecraft.banner.gradient.purple": "Fioletowy gradient",
  "block.minecraft.banner.gradient.red": "Czerwony gradient",
  "block.minecraft.banner.gradient.white": "Biały gradient",
  "block.minecraft.banner.gradient.yellow": "Żółty gradient",
  "block.minecraft.banner.gradient_up.black": "Czarny odwrócony gradient",
  "block.minecraft.banner.gradient_up.blue": "Niebieski odwrócony gradient",
  "block.minecraft.banner.gradient_up.brown": "Brązowy odwrócony gradient",
  "block.minecraft.banner.gradient_up.cyan": "Błękitny odwrócony gradient",
  "block.minecraft.banner.gradient_up.gray": "Szary odwrócony gradient",
  "block.minecraft.banner.gradient_up.green": "Zielony odwrócony gradient",
  "block.minecraft.banner.gradient_up.light_blue": "Jasnoniebieski odwrócony gradient",
  "block.minecraft.banner.gradient_up.light_gray": "Jasnoszary odwrócony gradient",
  "block.minecraft.banner.gradient_up.lime": "Jasnozielony odwrócony gradient",
  "block.minecraft.banner.gradient_up.magenta": "Purpurowy odwrócony gradient",
  "block.minecraft.banner.gradient_up.orange": "Pomarańczowy odwrócony gradient",
  "block.minecraft.banner.gradient_up.pink": "Różowy odwrócony gradient",
  "block.minecraft.banner.gradient_up.purple": "Fioletowy odwrócony gradient",
  "block.minecraft.banner.gradient_up.red": "Czerwony odwrócony gradient",
  "block.minecraft.banner.gradient_up.white": "Biały odwrócony gradient",
  "block.minecraft.banner.gradient_up.yellow": "Żółty odwrócony gradient",
  "block.minecraft.banner.guster.black": "Czarny podmuch",
  "block.minecraft.banner.guster.blue": "Niebieski podmuch",
  "block.minecraft.banner.guster.brown": "Brązowy podmuch",
  "block.minecraft.banner.guster.cyan": "Błękitny podmuch",
  "block.minecraft.banner.guster.gray": "Szary podmuch",
  "block.minecraft.banner.guster.green": "Zielony podmuch",
  "block.minecraft.banner.guster.light_blue": "Jasnoniebieski podmuch",
  "block.minecraft.banner.guster.light_gray": "Jasnoszary podmuch",
  "block.minecraft.banner.guster.lime": "Jasnozielony podmuch",
  "block.minecraft.banner.guster.magenta": "Purpurowy podmuch",
  "block.minecraft.banner.guster.orange": "Pomarańczowy podmuch",
  "block.minecraft.banner.guster.pink": "Różowy podmuch",
  "block.minecraft.banner.guster.purple": "Fioletowy podmuch",
  "block.minecraft.banner.guster.red": "Czerwony podmuch",
  "block.minecraft.banner.guster.white": "Biały podmuch",
  "block.minecraft.banner.guster.yellow": "Żółty podmuch",
  "block.minecraft.banner.half_horizontal.black": "Czarna górna połowa",
  "block.minecraft.banner.half_horizontal.blue": "Niebieska górna połowa",
  "block.minecraft.banner.half_horizontal.brown": "Brązowa górna połowa",
  "block.minecraft.banner.half_horizontal.cyan": "Błękitna górna połowa",
  "block.minecraft.banner.half_horizontal.gray": "Szara górna połowa",
  "block.minecraft.banner.half_horizontal.green": "Zielona górna połowa",
  "block.minecraft.banner.half_horizontal.light_blue": "Jasnoniebieska górna połowa",
  "block.minecraft.banner.half_horizontal.light_gray": "Jasnoszara górna połowa",
  "block.minecraft.banner.half_horizontal.lime": "Jasnozielona górna połowa",
  "block.minecraft.banner.half_horizontal.magenta": "Purpurowa górna połowa",
  "block.minecraft.banner.half_horizontal.orange": "Pomarańczowa górna połowa",
  "block.minecraft.banner.half_horizontal.pink": "Różowa górna połowa",
  "block.minecraft.banner.half_horizontal.purple": "Fioletowa górna połowa",
  "block.minecraft.banner.half_horizontal.red": "Czerwona górna połowa",
  "block.minecraft.banner.half_horizontal.white": "Biała górna połowa",
  "block.minecraft.banner.half_horizontal.yellow": "Żółta górna połowa",
  "block.minecraft.banner.half_horizontal_bottom.black": "Czarna dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Niebieska dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brązowa dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Błękitna dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Szara dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zielona dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Jasnoniebieska dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Jasnoszara dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Jasnozielona dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Purpurowa dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Pomarańczowa dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Różowa dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Fioletowa dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.red": "Czerwona dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.white": "Biała dolna połowa",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Żółta dolna połowa",
  "block.minecraft.banner.half_vertical.black": "Czarna lewa połowa",
  "block.minecraft.banner.half_vertical.blue": "Niebieska lewa połowa",
  "block.minecraft.banner.half_vertical.brown": "Brązowa lewa połowa",
  "block.minecraft.banner.half_vertical.cyan": "Błękitna lewa połowa",
  "block.minecraft.banner.half_vertical.gray": "Szara lewa połowa",
  "block.minecraft.banner.half_vertical.green": "Zielona lewa połowa",
  "block.minecraft.banner.half_vertical.light_blue": "Jasnoniebieska lewa połowa",
  "block.minecraft.banner.half_vertical.light_gray": "Jasnoszara lewa połowa",
  "block.minecraft.banner.half_vertical.lime": "Jasnozielona lewa połowa",
  "block.minecraft.banner.half_vertical.magenta": "Purpurowa lewa połowa",
  "block.minecraft.banner.half_vertical.orange": "Pomarańczowa lewa połowa",
  "block.minecraft.banner.half_vertical.pink": "Różowa lewa połowa",
  "block.minecraft.banner.half_vertical.purple": "Fioletowa lewa połowa",
  "block.minecraft.banner.half_vertical.red": "Czerwona lewa połowa",
  "block.minecraft.banner.half_vertical.white": "Biała lewa połowa",
  "block.minecraft.banner.half_vertical.yellow": "Żółta lewa połowa",
  "block.minecraft.banner.half_vertical_right.black": "Czarna prawa połowa",
  "block.minecraft.banner.half_vertical_right.blue": "Niebieska prawa połowa",
  "block.minecraft.banner.half_vertical_right.brown": "Brązowa prawa połowa",
  "block.minecraft.banner.half_vertical_right.cyan": "Błękitna prawa połowa",
  "block.minecraft.banner.half_vertical_right.gray": "Szara prawa połowa",
  "block.minecraft.banner.half_vertical_right.green": "Zielona prawa połowa",
  "block.minecraft.banner.half_vertical_right.light_blue": "Jasnoniebieska prawa połowa",
  "block.minecraft.banner.half_vertical_right.light_gray": "Jasnoszara prawa połowa",
  "block.minecraft.banner.half_vertical_right.lime": "Jasnozielona prawa połowa",
  "block.minecraft.banner.half_vertical_right.magenta": "Purpurowa prawa połowa",
  "block.minecraft.banner.half_vertical_right.orange": "Pomarańczowa prawa połowa",
  "block.minecraft.banner.half_vertical_right.pink": "Różowa prawa połowa",
  "block.minecraft.banner.half_vertical_right.purple": "Fioletowa prawa połowa",
  "block.minecraft.banner.half_vertical_right.red": "Czerwona prawa połowa",
  "block.minecraft.banner.half_vertical_right.white": "Biała prawa połowa",
  "block.minecraft.banner.half_vertical_right.yellow": "Żółta prawa połowa",
  "block.minecraft.banner.mojang.black": "Czarne Coś",
  "block.minecraft.banner.mojang.blue": "Niebieskie Coś",
  "block.minecraft.banner.mojang.brown": "Brązowe Coś",
  "block.minecraft.banner.mojang.cyan": "Błękitne Coś",
  "block.minecraft.banner.mojang.gray": "Szare Coś",
  "block.minecraft.banner.mojang.green": "Zielone Coś",
  "block.minecraft.banner.mojang.light_blue": "Jasnoniebieskie Coś",
  "block.minecraft.banner.mojang.light_gray": "Jasnoszare Coś",
  "block.minecraft.banner.mojang.lime": "Jasnozielone Coś",
  "block.minecraft.banner.mojang.magenta": "Purpurowe Coś",
  "block.minecraft.banner.mojang.orange": "Pomarańczowe Coś",
  "block.minecraft.banner.mojang.pink": "Różowe Coś",
  "block.minecraft.banner.mojang.purple": "Fioletowe Coś",
  "block.minecraft.banner.mojang.red": "Czerwone Coś",
  "block.minecraft.banner.mojang.white": "Białe Coś",
  "block.minecraft.banner.mojang.yellow": "Żółte Coś",
  "block.minecraft.banner.piglin.black": "Czarny ryjek",
  "block.minecraft.banner.piglin.blue": "Niebieski ryjek",
  "block.minecraft.banner.piglin.brown": "Brązowy ryjek",
  "block.minecraft.banner.piglin.cyan": "Błękitny ryjek",
  "block.minecraft.banner.piglin.gray": "Szary ryjek",
  "block.minecraft.banner.piglin.green": "Zielony ryjek",
  "block.minecraft.banner.piglin.light_blue": "Jasnoniebieski ryjek",
  "block.minecraft.banner.piglin.light_gray": "Jasnoszary ryjek",
  "block.minecraft.banner.piglin.lime": "Jasnozielony ryjek",
  "block.minecraft.banner.piglin.magenta": "Purpurowy ryjek",
  "block.minecraft.banner.piglin.orange": "Pomarańczowy ryjek",
  "block.minecraft.banner.piglin.pink": "Różowy ryjek",
  "block.minecraft.banner.piglin.purple": "Fioletowy ryjek",
  "block.minecraft.banner.piglin.red": "Czerwony ryjek",
  "block.minecraft.banner.piglin.white": "Biały ryjek",
  "block.minecraft.banner.piglin.yellow": "Żółty ryjek",
  "block.minecraft.banner.rhombus.black": "Czarny romb",
  "block.minecraft.banner.rhombus.blue": "Niebieski romb",
  "block.minecraft.banner.rhombus.brown": "Brązowy romb",
  "block.minecraft.banner.rhombus.cyan": "Błękitny romb",
  "block.minecraft.banner.rhombus.gray": "Szary romb",
  "block.minecraft.banner.rhombus.green": "Zielony romb",
  "block.minecraft.banner.rhombus.light_blue": "Jasnoniebieski romb",
  "block.minecraft.banner.rhombus.light_gray": "Jasnoszary romb",
  "block.minecraft.banner.rhombus.lime": "Jasnozielony romb",
  "block.minecraft.banner.rhombus.magenta": "Purpurowy romb",
  "block.minecraft.banner.rhombus.orange": "Pomarańczowy romb",
  "block.minecraft.banner.rhombus.pink": "Różowy romb",
  "block.minecraft.banner.rhombus.purple": "Fioletowy romb",
  "block.minecraft.banner.rhombus.red": "Czerwony romb",
  "block.minecraft.banner.rhombus.white": "Biały romb",
  "block.minecraft.banner.rhombus.yellow": "Żółty romb",
  "block.minecraft.banner.skull.black": "Czarny wzór czaszki",
  "block.minecraft.banner.skull.blue": "Niebieski wzór czaszki",
  "block.minecraft.banner.skull.brown": "Brązowy wzór czaszki",
  "block.minecraft.banner.skull.cyan": "Błękitny wzór czaszki",
  "block.minecraft.banner.skull.gray": "Szary wzór czaszki",
  "block.minecraft.banner.skull.green": "Zielony wzór czaszki",
  "block.minecraft.banner.skull.light_blue": "Jasnoniebieski wzór czaszki",
  "block.minecraft.banner.skull.light_gray": "Jasnoszary wzór czaszki",
  "block.minecraft.banner.skull.lime": "Jasnozielony wzór czaszki",
  "block.minecraft.banner.skull.magenta": "Purpurowy wzór czaszki",
  "block.minecraft.banner.skull.orange": "Pomarańczowy wzór czaszki",
  "block.minecraft.banner.skull.pink": "Różowy wzór czaszki",
  "block.minecraft.banner.skull.purple": "Fioletowy wzór czaszki",
  "block.minecraft.banner.skull.red": "Czerwony wzór czaszki",
  "block.minecraft.banner.skull.white": "Biały wzór czaszki",
  "block.minecraft.banner.skull.yellow": "Żółty wzór czaszki",
  "block.minecraft.banner.small_stripes.black": "Czarne pasy",
  "block.minecraft.banner.small_stripes.blue": "Niebieskie pasy",
  "block.minecraft.banner.small_stripes.brown": "Brązowe pasy",
  "block.minecraft.banner.small_stripes.cyan": "Błękitne pasy",
  "block.minecraft.banner.small_stripes.gray": "Szare pasy",
  "block.minecraft.banner.small_stripes.green": "Zielone pasy",
  "block.minecraft.banner.small_stripes.light_blue": "Jasnoniebieskie pasy",
  "block.minecraft.banner.small_stripes.light_gray": "Jasnoszare pasy",
  "block.minecraft.banner.small_stripes.lime": "Jasnozielone pasy",
  "block.minecraft.banner.small_stripes.magenta": "Purpurowe pasy",
  "block.minecraft.banner.small_stripes.orange": "Pomarańczowe pasy",
  "block.minecraft.banner.small_stripes.pink": "Różowe pasy",
  "block.minecraft.banner.small_stripes.purple": "Fioletowe pasy",
  "block.minecraft.banner.small_stripes.red": "Czerwone pasy",
  "block.minecraft.banner.small_stripes.white": "Białe pasy",
  "block.minecraft.banner.small_stripes.yellow": "Żółte pasy",
  "block.minecraft.banner.square_bottom_left.black": "Czarny dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.blue": "Niebieski dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.brown": "Brązowy dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.cyan": "Błękitny dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.gray": "Szary dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.green": "Zielony dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.light_blue": "Jasnoniebieski dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.light_gray": "Jasnoszary dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.lime": "Jasnozielony dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.magenta": "Purpurowy dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.orange": "Pomarańczowy dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.pink": "Różowy dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.purple": "Fioletowy dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.red": "Czerwony dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.white": "Biały dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_left.yellow": "Żółty dolny lewy narożnik",
  "block.minecraft.banner.square_bottom_right.black": "Czarny dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.blue": "Niebieski dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.brown": "Brązowy dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.cyan": "Błękitny dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.gray": "Szary dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.green": "Zielony dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.light_blue": "Jasnoniebieski dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.light_gray": "Jasnoszary dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.lime": "Jasnozielony dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.magenta": "Purpurowy dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.orange": "Pomarańczowy dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.pink": "Różowy dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.purple": "Fioletowy dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.red": "Czerwony dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.white": "Biały dolny prawy narożnik",
  "block.minecraft.banner.square_bottom_right.yellow": "Żółty dolny prawy narożnik",
  "block.minecraft.banner.square_top_left.black": "Czarny górny lewy narożnik",
  "block.minecraft.banner.square_top_left.blue": "Niebieski górny lewy narożnik",
  "block.minecraft.banner.square_top_left.brown": "Brązowy górny lewy narożnik",
  "block.minecraft.banner.square_top_left.cyan": "Błękitny górny lewy narożnik",
  "block.minecraft.banner.square_top_left.gray": "Szary górny lewy narożnik",
  "block.minecraft.banner.square_top_left.green": "Zielony górny lewy narożnik",
  "block.minecraft.banner.square_top_left.light_blue": "Jasnoniebieski górny lewy narożnik",
  "block.minecraft.banner.square_top_left.light_gray": "Jasnoszary górny lewy narożnik",
  "block.minecraft.banner.square_top_left.lime": "Jasnozielony górny lewy narożnik",
  "block.minecraft.banner.square_top_left.magenta": "Purpurowy górny lewy narożnik",
  "block.minecraft.banner.square_top_left.orange": "Pomarańczowy górny lewy narożnik",
  "block.minecraft.banner.square_top_left.pink": "Różowy górny lewy narożnik",
  "block.minecraft.banner.square_top_left.purple": "Fioletowy górny lewy narożnik",
  "block.minecraft.banner.square_top_left.red": "Czerwony górny lewy narożnik",
  "block.minecraft.banner.square_top_left.white": "Biały górny lewy narożnik",
  "block.minecraft.banner.square_top_left.yellow": "Żółty górny lewy narożnik",
  "block.minecraft.banner.square_top_right.black": "Czarny górny prawy narożnik",
  "block.minecraft.banner.square_top_right.blue": "Niebieski górny prawy narożnik",
  "block.minecraft.banner.square_top_right.brown": "Brązowy górny prawy narożnik",
  "block.minecraft.banner.square_top_right.cyan": "Błękitny górny prawy narożnik",
  "block.minecraft.banner.square_top_right.gray": "Szary górny prawy narożnik",
  "block.minecraft.banner.square_top_right.green": "Zielony górny prawy narożnik",
  "block.minecraft.banner.square_top_right.light_blue": "Jasnoniebieski górny prawy narożnik",
  "block.minecraft.banner.square_top_right.light_gray": "Jasnoszary górny prawy narożnik",
  "block.minecraft.banner.square_top_right.lime": "Jasnozielony górny prawy narożnik",
  "block.minecraft.banner.square_top_right.magenta": "Purpurowy górny prawy narożnik",
  "block.minecraft.banner.square_top_right.orange": "Pomarańczowy górny prawy narożnik",
  "block.minecraft.banner.square_top_right.pink": "Różowy górny prawy narożnik",
  "block.minecraft.banner.square_top_right.purple": "Fioletowy górny prawy narożnik",
  "block.minecraft.banner.square_top_right.red": "Czerwony górny prawy narożnik",
  "block.minecraft.banner.square_top_right.white": "Biały górny prawy narożnik",
  "block.minecraft.banner.square_top_right.yellow": "Żółty górny prawy narożnik",
  "block.minecraft.banner.straight_cross.black": "Czarny krzyż",
  "block.minecraft.banner.straight_cross.blue": "Niebieski krzyż",
  "block.minecraft.banner.straight_cross.brown": "Brązowy krzyż",
  "block.minecraft.banner.straight_cross.cyan": "Błękitny krzyż",
  "block.minecraft.banner.straight_cross.gray": "Szary krzyż",
  "block.minecraft.banner.straight_cross.green": "Zielony krzyż",
  "block.minecraft.banner.straight_cross.light_blue": "Jasnoniebieski krzyż",
  "block.minecraft.banner.straight_cross.light_gray": "Jasnoszary krzyż",
  "block.minecraft.banner.straight_cross.lime": "Jasnozielony krzyż",
  "block.minecraft.banner.straight_cross.magenta": "Purpurowy krzyż",
  "block.minecraft.banner.straight_cross.orange": "Pomarańczowy krzyż",
  "block.minecraft.banner.straight_cross.pink": "Różowy krzyż",
  "block.minecraft.banner.straight_cross.purple": "Fioletowy krzyż",
  "block.minecraft.banner.straight_cross.red": "Czerwony krzyż",
  "block.minecraft.banner.straight_cross.white": "Biały krzyż",
  "block.minecraft.banner.straight_cross.yellow": "Żółty krzyż",
  "block.minecraft.banner.stripe_bottom.black": "Czarna podstawa",
  "block.minecraft.banner.stripe_bottom.blue": "Niebieska podstawa",
  "block.minecraft.banner.stripe_bottom.brown": "Brązowa podstawa",
  "block.minecraft.banner.stripe_bottom.cyan": "Błękitna podstawa",
  "block.minecraft.banner.stripe_bottom.gray": "Szara podstawa",
  "block.minecraft.banner.stripe_bottom.green": "Zielona podstawa",
  "block.minecraft.banner.stripe_bottom.light_blue": "Jasnoniebieska podstawa",
  "block.minecraft.banner.stripe_bottom.light_gray": "Jasnoszara podstawa",
  "block.minecraft.banner.stripe_bottom.lime": "Jasnozielona podstawa",
  "block.minecraft.banner.stripe_bottom.magenta": "Purpurowa podstawa",
  "block.minecraft.banner.stripe_bottom.orange": "Pomarańczowa podstawa",
  "block.minecraft.banner.stripe_bottom.pink": "Różowa podstawa",
  "block.minecraft.banner.stripe_bottom.purple": "Fioletowa podstawa",
  "block.minecraft.banner.stripe_bottom.red": "Czerwona podstawa",
  "block.minecraft.banner.stripe_bottom.white": "Biała podstawa",
  "block.minecraft.banner.stripe_bottom.yellow": "Żółta podstawa",
  "block.minecraft.banner.stripe_center.black": "Czarny słup",
  "block.minecraft.banner.stripe_center.blue": "Niebieski słup",
  "block.minecraft.banner.stripe_center.brown": "Brązowy słup",
  "block.minecraft.banner.stripe_center.cyan": "Błękitny słup",
  "block.minecraft.banner.stripe_center.gray": "Szary słup",
  "block.minecraft.banner.stripe_center.green": "Zielony słup",
  "block.minecraft.banner.stripe_center.light_blue": "Jasnoniebieski słup",
  "block.minecraft.banner.stripe_center.light_gray": "Jasnoszary słup",
  "block.minecraft.banner.stripe_center.lime": "Jasnozielony słup",
  "block.minecraft.banner.stripe_center.magenta": "Purpurowy słup",
  "block.minecraft.banner.stripe_center.orange": "Pomarańczowy słup",
  "block.minecraft.banner.stripe_center.pink": "Różowy słup",
  "block.minecraft.banner.stripe_center.purple": "Fioletowy słup",
  "block.minecraft.banner.stripe_center.red": "Czerwony słup",
  "block.minecraft.banner.stripe_center.white": "Biały słup",
  "block.minecraft.banner.stripe_center.yellow": "Żółty słup",
  "block.minecraft.banner.stripe_downleft.black": "Czarny lewy skos",
  "block.minecraft.banner.stripe_downleft.blue": "Niebieski lewy skos",
  "block.minecraft.banner.stripe_downleft.brown": "Brązowy lewy skos",
  "block.minecraft.banner.stripe_downleft.cyan": "Błękitny lewy skos",
  "block.minecraft.banner.stripe_downleft.gray": "Szary lewy skos",
  "block.minecraft.banner.stripe_downleft.green": "Zielony lewy skos",
  "block.minecraft.banner.stripe_downleft.light_blue": "Jasnoniebieski lewy skos",
  "block.minecraft.banner.stripe_downleft.light_gray": "Jasnoszary lewy skos",
  "block.minecraft.banner.stripe_downleft.lime": "Jasnozielony lewy skos",
  "block.minecraft.banner.stripe_downleft.magenta": "Purpurowy lewy skos",
  "block.minecraft.banner.stripe_downleft.orange": "Pomarańczowy lewy skos",
  "block.minecraft.banner.stripe_downleft.pink": "Różowy lewy skos",
  "block.minecraft.banner.stripe_downleft.purple": "Fioletowy lewy skos",
  "block.minecraft.banner.stripe_downleft.red": "Czerwony lewy skos",
  "block.minecraft.banner.stripe_downleft.white": "Biały lewy skos",
  "block.minecraft.banner.stripe_downleft.yellow": "Żółty lewy skos",
  "block.minecraft.banner.stripe_downright.black": "Czarny prawy skos",
  "block.minecraft.banner.stripe_downright.blue": "Niebieski prawy skos",
  "block.minecraft.banner.stripe_downright.brown": "Brązowy prawy skos",
  "block.minecraft.banner.stripe_downright.cyan": "Błękitny prawy skos",
  "block.minecraft.banner.stripe_downright.gray": "Szary prawy skos",
  "block.minecraft.banner.stripe_downright.green": "Zielony prawy skos",
  "block.minecraft.banner.stripe_downright.light_blue": "Jasnoniebieski prawy skos",
  "block.minecraft.banner.stripe_downright.light_gray": "Jasnoszary prawy skos",
  "block.minecraft.banner.stripe_downright.lime": "Jasnozielony prawy skos",
  "block.minecraft.banner.stripe_downright.magenta": "Purpurowy prawy skos",
  "block.minecraft.banner.stripe_downright.orange": "Pomarańczowy prawy skos",
  "block.minecraft.banner.stripe_downright.pink": "Różowy prawy skos",
  "block.minecraft.banner.stripe_downright.purple": "Fioletowy prawy skos",
  "block.minecraft.banner.stripe_downright.red": "Czerwony prawy skos",
  "block.minecraft.banner.stripe_downright.white": "Biały prawy skos",
  "block.minecraft.banner.stripe_downright.yellow": "Żółty prawy skos",
  "block.minecraft.banner.stripe_left.black": "Czarna lewa flanka",
  "block.minecraft.banner.stripe_left.blue": "Niebieska lewa flanka",
  "block.minecraft.banner.stripe_left.brown": "Brązowa lewa flanka",
  "block.minecraft.banner.stripe_left.cyan": "Błękitna lewa flanka",
  "block.minecraft.banner.stripe_left.gray": "Szara lewa flanka",
  "block.minecraft.banner.stripe_left.green": "Zielona lewa flanka",
  "block.minecraft.banner.stripe_left.light_blue": "Jasnoniebieska lewa flanka",
  "block.minecraft.banner.stripe_left.light_gray": "Jasnoszara lewa flanka",
  "block.minecraft.banner.stripe_left.lime": "Jasnozielona lewa flanka",
  "block.minecraft.banner.stripe_left.magenta": "Purpurowa lewa flanka",
  "block.minecraft.banner.stripe_left.orange": "Pomarańczowa lewa flanka",
  "block.minecraft.banner.stripe_left.pink": "Różowa lewa flanka",
  "block.minecraft.banner.stripe_left.purple": "Fioletowa lewa flanka",
  "block.minecraft.banner.stripe_left.red": "Czerwona lewa flanka",
  "block.minecraft.banner.stripe_left.white": "Biała lewa flanka",
  "block.minecraft.banner.stripe_left.yellow": "Żółta lewa flanka",
  "block.minecraft.banner.stripe_middle.black": "Czarny poziomy pas",
  "block.minecraft.banner.stripe_middle.blue": "Niebieski poziomy pas",
  "block.minecraft.banner.stripe_middle.brown": "Brązowy poziomy pas",
  "block.minecraft.banner.stripe_middle.cyan": "Błękitny poziomy pas",
  "block.minecraft.banner.stripe_middle.gray": "Szary poziomy pas",
  "block.minecraft.banner.stripe_middle.green": "Zielony poziomy pas",
  "block.minecraft.banner.stripe_middle.light_blue": "Jasnoniebieski poziomy pas",
  "block.minecraft.banner.stripe_middle.light_gray": "Jasnoszary poziomy pas",
  "block.minecraft.banner.stripe_middle.lime": "Jasnozielony poziomy pas",
  "block.minecraft.banner.stripe_middle.magenta": "Purpurowy poziomy pas",
  "block.minecraft.banner.stripe_middle.orange": "Pomarańczowy poziomy pas",
  "block.minecraft.banner.stripe_middle.pink": "Różowy poziomy pas",
  "block.minecraft.banner.stripe_middle.purple": "Fioletowy poziomy pas",
  "block.minecraft.banner.stripe_middle.red": "Czerwony poziomy pas",
  "block.minecraft.banner.stripe_middle.white": "Biały poziomy pas",
  "block.minecraft.banner.stripe_middle.yellow": "Żółty poziomy pas",
  "block.minecraft.banner.stripe_right.black": "Czarna prawa flanka",
  "block.minecraft.banner.stripe_right.blue": "Niebieska prawa flanka",
  "block.minecraft.banner.stripe_right.brown": "Brązowa prawa flanka",
  "block.minecraft.banner.stripe_right.cyan": "Błękitna prawa flanka",
  "block.minecraft.banner.stripe_right.gray": "Szara prawa flanka",
  "block.minecraft.banner.stripe_right.green": "Zielona prawa flanka",
  "block.minecraft.banner.stripe_right.light_blue": "Jasnoniebieska prawa flanka",
  "block.minecraft.banner.stripe_right.light_gray": "Jasnoszara prawa flanka",
  "block.minecraft.banner.stripe_right.lime": "Jasnozielona prawa flanka",
  "block.minecraft.banner.stripe_right.magenta": "Purpurowa prawa flanka",
  "block.minecraft.banner.stripe_right.orange": "Pomarańczowa prawa flanka",
  "block.minecraft.banner.stripe_right.pink": "Różowa prawa flanka",
  "block.minecraft.banner.stripe_right.purple": "Fioletowa prawa flanka",
  "block.minecraft.banner.stripe_right.red": "Czerwona prawa flanka",
  "block.minecraft.banner.stripe_right.white": "Biała prawa flanka",
  "block.minecraft.banner.stripe_right.yellow": "Żółta prawa flanka",
  "block.minecraft.banner.stripe_top.black": "Czarna głowica",
  "block.minecraft.banner.stripe_top.blue": "Niebieska głowica",
  "block.minecraft.banner.stripe_top.brown": "Brązowa głowica",
  "block.minecraft.banner.stripe_top.cyan": "Błękitna głowica",
  "block.minecraft.banner.stripe_top.gray": "Szara głowica",
  "block.minecraft.banner.stripe_top.green": "Zielona głowica",
  "block.minecraft.banner.stripe_top.light_blue": "Jasnoniebieska głowica",
  "block.minecraft.banner.stripe_top.light_gray": "Jasnoszara głowica",
  "block.minecraft.banner.stripe_top.lime": "Jasnozielona głowica",
  "block.minecraft.banner.stripe_top.magenta": "Purpurowa głowica",
  "block.minecraft.banner.stripe_top.orange": "Pomarańczowa głowica",
  "block.minecraft.banner.stripe_top.pink": "Różowa głowica",
  "block.minecraft.banner.stripe_top.purple": "Fioletowa głowica",
  "block.minecraft.banner.stripe_top.red": "Czerwona głowica",
  "block.minecraft.banner.stripe_top.white": "Biała głowica",
  "block.minecraft.banner.stripe_top.yellow": "Żółta głowica",
  "block.minecraft.banner.triangle_bottom.black": "Czarna krokiew",
  "block.minecraft.banner.triangle_bottom.blue": "Niebieska krokiew",
  "block.minecraft.banner.triangle_bottom.brown": "Brązowa krokiew",
  "block.minecraft.banner.triangle_bottom.cyan": "Błękitna krokiew",
  "block.minecraft.banner.triangle_bottom.gray": "Szara krokiew",
  "block.minecraft.banner.triangle_bottom.green": "Zielona krokiew",
  "block.minecraft.banner.triangle_bottom.light_blue": "Jasnoniebieska krokiew",
  "block.minecraft.banner.triangle_bottom.light_gray": "Jasnoszara krokiew",
  "block.minecraft.banner.triangle_bottom.lime": "Jasnozielona krokiew",
  "block.minecraft.banner.triangle_bottom.magenta": "Purpurowa krokiew",
  "block.minecraft.banner.triangle_bottom.orange": "Pomarańczowa krokiew",
  "block.minecraft.banner.triangle_bottom.pink": "Różowa krokiew",
  "block.minecraft.banner.triangle_bottom.purple": "Fioletowa krokiew",
  "block.minecraft.banner.triangle_bottom.red": "Czerwona krokiew",
  "block.minecraft.banner.triangle_bottom.white": "Biała krokiew",
  "block.minecraft.banner.triangle_bottom.yellow": "Żółta krokiew",
  "block.minecraft.banner.triangle_top.black": "Czarna odwrócona krokiew",
  "block.minecraft.banner.triangle_top.blue": "Niebieska odwrócona krokiew",
  "block.minecraft.banner.triangle_top.brown": "Brązowa odwrócona krokiew",
  "block.minecraft.banner.triangle_top.cyan": "Błękitna odwrócona krokiew",
  "block.minecraft.banner.triangle_top.gray": "Szara odwrócona krokiew",
  "block.minecraft.banner.triangle_top.green": "Zielona odwrócona krokiew",
  "block.minecraft.banner.triangle_top.light_blue": "Jasnoniebieska odwrócona krokiew",
  "block.minecraft.banner.triangle_top.light_gray": "Jasnoszara odwrócona krokiew",
  "block.minecraft.banner.triangle_top.lime": "Jasnozielona odwrócona krokiew",
  "block.minecraft.banner.triangle_top.magenta": "Purpurowa odwrócona krokiew",
  "block.minecraft.banner.triangle_top.orange": "Pomarańczowa odwrócona krokiew",
  "block.minecraft.banner.triangle_top.pink": "Różowa odwrócona krokiew",
  "block.minecraft.banner.triangle_top.purple": "Fioletowa odwrócona krokiew",
  "block.minecraft.banner.triangle_top.red": "Czerwona odwrócona krokiew",
  "block.minecraft.banner.triangle_top.white": "Biała odwrócona krokiew",
  "block.minecraft.banner.triangle_top.yellow": "Żółta odwrócona krokiew",
  "block.minecraft.banner.triangles_bottom.black": "Czarna podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.blue": "Niebieska podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.brown": "Brązowa podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.cyan": "Błękitna podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.gray": "Szara podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.green": "Zielona podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.light_blue": "Jasnoniebieska podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.light_gray": "Jasnoszara podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.lime": "Jasnozielona podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.magenta": "Purpurowa podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.orange": "Pomarańczowa podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.pink": "Różowa podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.purple": "Fioletowa podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.red": "Czerwona podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.white": "Biała podstawa ząbkowana",
  "block.minecraft.banner.triangles_bottom.yellow": "Żółta podstawa ząbkowana",
  "block.minecraft.banner.triangles_top.black": "Czarna głowica ząbkowana",
  "block.minecraft.banner.triangles_top.blue": "Niebieska głowica ząbkowana",
  "block.minecraft.banner.triangles_top.brown": "Brązowa głowica ząbkowana",
  "block.minecraft.banner.triangles_top.cyan": "Błękitna głowica ząbkowana",
  "block.minecraft.banner.triangles_top.gray": "Szara głowica ząbkowana",
  "block.minecraft.banner.triangles_top.green": "Zielona głowica ząbkowana",
  "block.minecraft.banner.triangles_top.light_blue": "Jasnoniebieska głowica ząbkowana",
  "block.minecraft.banner.triangles_top.light_gray": "Jasnoszara głowica ząbkowana",
  "block.minecraft.banner.triangles_top.lime": "Jasnozielona głowica ząbkowana",
  "block.minecraft.banner.triangles_top.magenta": "Purpurowa głowica ząbkowana",
  "block.minecraft.banner.triangles_top.orange": "Pomarańczowa głowica ząbkowana",
  "block.minecraft.banner.triangles_top.pink": "Różowa głowica ząbkowana",
  "block.minecraft.banner.triangles_top.purple": "Fioletowa głowica ząbkowana",
  "block.minecraft.banner.triangles_top.red": "Czerwona głowica ząbkowana",
  "block.minecraft.banner.triangles_top.white": "Biała głowica ząbkowana",
  "block.minecraft.banner.triangles_top.yellow": "Żółta głowica ząbkowana",
  "block.minecraft.barrel": "Beczka",
  "block.minecraft.barrier": "Bariera",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Magiczna latarnia",
  "block.minecraft.beacon.primary": "Moc podstawowa",
  "block.minecraft.beacon.secondary": "Moc dodatkowa",
  "block.minecraft.bed.no_sleep": "Możesz spać tylko w nocy lub podczas burzy",
  "block.minecraft.bed.not_safe": "Nie możesz teraz odpoczywać; w pobliżu są potwory",
  "block.minecraft.bed.obstructed": "To łóżko jest zajęte",
  "block.minecraft.bed.occupied": "To łóżko jest zajęte",
  "block.minecraft.bed.too_far_away": "Nie możesz teraz odpoczywać; łóżko jest zbyt daleko",
  "block.minecraft.bedrock": "Skała macierzysta",
  "block.minecraft.bee_nest": "Gniazdo pszczół",
  "block.minecraft.beehive": "Ul",
  "block.minecraft.beetroots": "Buraki",
  "block.minecraft.bell": "Dzwon",
  "block.minecraft.big_dripleaf": "Wielki spadkoliść",
  "block.minecraft.big_dripleaf_stem": "Łodyga wielkiego spadkoliścia",
  "block.minecraft.birch_button": "Brzozowy przycisk",
  "block.minecraft.birch_door": "Brzozowe drzwi",
  "block.minecraft.birch_fence": "Brzozowy płot",
  "block.minecraft.birch_fence_gate": "Brzozowa furtka",
  "block.minecraft.birch_hanging_sign": "Brzozowa podwieszana tabliczka",
  "block.minecraft.birch_leaves": "Brzozowe liście",
  "block.minecraft.birch_log": "Brzozowy pień",
  "block.minecraft.birch_planks": "Brzozowe deski",
  "block.minecraft.birch_pressure_plate": "Brzozowa płytka naciskowa",
  "block.minecraft.birch_sapling": "Sadzonka brzozy",
  "block.minecraft.birch_shelf": "Brzozowa półka",
  "block.minecraft.birch_sign": "Brzozowa tabliczka",
  "block.minecraft.birch_slab": "Brzozowa płyta",
  "block.minecraft.birch_stairs": "Brzozowe schody",
  "block.minecraft.birch_trapdoor": "Brzozowa klapa",
  "block.minecraft.birch_wall_hanging_sign": "Brzozowa ścienna podwieszana tabliczka",
  "block.minecraft.birch_wall_sign": "Brzozowa ścienna tabliczka",
  "block.minecraft.birch_wood": "Brzozowe drewno",
  "block.minecraft.black_banner": "Czarny sztandar",
  "block.minecraft.black_bed": "Czarne łóżko",
  "block.minecraft.black_candle": "Czarna świeca",
  "block.minecraft.black_candle_cake": "Ciasto z czarną świeczką",
  "block.minecraft.black_carpet": "Czarny dywan",
  "block.minecraft.black_concrete": "Czarny beton",
  "block.minecraft.black_concrete_powder": "Czarny cement",
  "block.minecraft.black_glazed_terracotta": "Czarna glazurowana terakota",
  "block.minecraft.black_shulker_box": "Czarna shulkerowa skrzynia",
  "block.minecraft.black_stained_glass": "Czarne szkło",
  "block.minecraft.black_stained_glass_pane": "Czarna szyba",
  "block.minecraft.black_terracotta": "Czarna terakota",
  "block.minecraft.black_wool": "Czarna wełna",
  "block.minecraft.blackstone": "Czernit",
  "block.minecraft.blackstone_slab": "Czernitowa płyta",
  "block.minecraft.blackstone_stairs": "Czernitowe schody",
  "block.minecraft.blackstone_wall": "Czernitowy murek",
  "block.minecraft.blast_furnace": "Piec hutniczy",
  "block.minecraft.blue_banner": "Niebieski sztandar",
  "block.minecraft.blue_bed": "Niebieskie łóżko",
  "block.minecraft.blue_candle": "Niebieska świeca",
  "block.minecraft.blue_candle_cake": "Ciasto z niebieską świeczką",
  "block.minecraft.blue_carpet": "Niebieski dywan",
  "block.minecraft.blue_concrete": "Niebieski beton",
  "block.minecraft.blue_concrete_powder": "Niebieski cement",
  "block.minecraft.blue_glazed_terracotta": "Niebieska glazurowana terakota",
  "block.minecraft.blue_ice": "Niebieski lód lodowcowy",
  "block.minecraft.blue_orchid": "Niebieska orchidea",
  "block.minecraft.blue_shulker_box": "Niebieska shulkerowa skrzynia",
  "block.minecraft.blue_stained_glass": "Niebieskie szkło",
  "block.minecraft.blue_stained_glass_pane": "Niebieska szyba",
  "block.minecraft.blue_terracotta": "Niebieska terakota",
  "block.minecraft.blue_wool": "Niebieska wełna",
  "block.minecraft.bone_block": "Blok kości",
  "block.minecraft.bookshelf": "Biblioteczka",
  "block.minecraft.brain_coral": "Koralowiec mózgowaty",
  "block.minecraft.brain_coral_block": "Blok koralowca mózgowatego",
  "block.minecraft.brain_coral_fan": "Wachlarz koralowca mózgowatego",
  "block.minecraft.brain_coral_wall_fan": "Wachlarz naścienny koralowca mózgowatego",
  "block.minecraft.brewing_stand": "Statyw alchemiczny",
  "block.minecraft.brick_slab": "Ceglana płyta",
  "block.minecraft.brick_stairs": "Ceglane schody",
  "block.minecraft.brick_wall": "Ceglany murek",
  "block.minecraft.bricks": "Cegły",
  "block.minecraft.brown_banner": "Brązowy sztandar",
  "block.minecraft.brown_bed": "Brązowe łóżko",
  "block.minecraft.brown_candle": "Brązowa świeca",
  "block.minecraft.brown_candle_cake": "Ciasto z brązową świeczką",
  "block.minecraft.brown_carpet": "Brązowy dywan",
  "block.minecraft.brown_concrete": "Brązowy beton",
  "block.minecraft.brown_concrete_powder": "Brązowy cement",
  "block.minecraft.brown_glazed_terracotta": "Brązowa glazurowana terakota",
  "block.minecraft.brown_mushroom": "Borowik",
  "block.minecraft.brown_mushroom_block": "Blok borowika",
  "block.minecraft.brown_shulker_box": "Brązowa shulkerowa skrzynia",
  "block.minecraft.brown_stained_glass": "Brązowe szkło",
  "block.minecraft.brown_stained_glass_pane": "Brązowa szyba",
  "block.minecraft.brown_terracotta": "Brązowa terakota",
  "block.minecraft.brown_wool": "Brązowa wełna",
  "block.minecraft.bubble_column": "Kolumna bąbelków",
  "block.minecraft.bubble_coral": "Koralowiec bąbelkowaty",
  "block.minecraft.bubble_coral_block": "Blok koralowca bąbelkowatego",
  "block.minecraft.bubble_coral_fan": "Wachlarz koralowca bąbelkowatego",
  "block.minecraft.bubble_coral_wall_fan": "Wachlarz naścienny koralowca bąbelkowatego",
  "block.minecraft.budding_amethyst": "Kiełkujący ametyst",
  "block.minecraft.bush": "Krzew",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kwiat kaktusa",
  "block.minecraft.cake": "Ciasto",
  "block.minecraft.calcite": "Kalcyt",
  "block.minecraft.calibrated_sculk_sensor": "Skalibrowany sculkowy czujnik",
  "block.minecraft.campfire": "Ognisko",
  "block.minecraft.candle": "Świeca",
  "block.minecraft.candle_cake": "Ciasto ze świeczką",
  "block.minecraft.carrots": "Marchewki",
  "block.minecraft.cartography_table": "Stół kartograficzny",
  "block.minecraft.carved_pumpkin": "Wykrawana dynia",
  "block.minecraft.cauldron": "Kocioł",
  "block.minecraft.cave_air": "Powietrze jaskiniowe",
  "block.minecraft.cave_vines": "Jaskiniowe pnącza",
  "block.minecraft.cave_vines_plant": "Rosnące jaskiniowe pnącza",
  "block.minecraft.chain": "Łańcuch",
  "block.minecraft.chain_command_block": "Łańcuchowy blok poleceń",
  "block.minecraft.cherry_button": "Wiśniowy przycisk",
  "block.minecraft.cherry_door": "Wiśniowe drzwi",
  "block.minecraft.cherry_fence": "Wiśniowy płot",
  "block.minecraft.cherry_fence_gate": "Wiśniowa furtka",
  "block.minecraft.cherry_hanging_sign": "Wiśniowa podwieszana tabliczka",
  "block.minecraft.cherry_leaves": "Wiśniowe liście",
  "block.minecraft.cherry_log": "Wiśniowy pień",
  "block.minecraft.cherry_planks": "Wiśniowe deski",
  "block.minecraft.cherry_pressure_plate": "Wiśniowa płytka naciskowa",
  "block.minecraft.cherry_sapling": "Sadzonka wiśni",
  "block.minecraft.cherry_shelf": "Wiśniowa półka",
  "block.minecraft.cherry_sign": "Wiśniowa tabliczka",
  "block.minecraft.cherry_slab": "Wiśniowa płyta",
  "block.minecraft.cherry_stairs": "Wiśniowe schody",
  "block.minecraft.cherry_trapdoor": "Wiśniowa klapa",
  "block.minecraft.cherry_wall_hanging_sign": "Wiśniowa ścienna podwieszana tabliczka",
  "block.minecraft.cherry_wall_sign": "Wiśniowa ścienna tabliczka",
  "block.minecraft.cherry_wood": "Wiśniowe drewno",
  "block.minecraft.chest": "Skrzynia",
  "block.minecraft.chipped_anvil": "Wyszczerbione kowadło",
  "block.minecraft.chiseled_bookshelf": "Rzeźbiona biblioteczka",
  "block.minecraft.chiseled_copper": "Rzeźbiona miedź",
  "block.minecraft.chiseled_deepslate": "Rzeźbiony łupek",
  "block.minecraft.chiseled_nether_bricks": "Rzeźbione netherowe cegły",
  "block.minecraft.chiseled_polished_blackstone": "Rzeźbiony wypolerowany czernit",
  "block.minecraft.chiseled_quartz_block": "Rzeźbiony blok kwarcu",
  "block.minecraft.chiseled_red_sandstone": "Rzeźbiony czerwony piaskowiec",
  "block.minecraft.chiseled_resin_bricks": "Rzeźbione żywicowe cegły",
  "block.minecraft.chiseled_sandstone": "Rzeźbiony piaskowiec",
  "block.minecraft.chiseled_stone_bricks": "Rzeźbione kamienne cegły",
  "block.minecraft.chiseled_tuff": "Rzeźbiony tuf",
  "block.minecraft.chiseled_tuff_bricks": "Rzeźbione tufowe cegły",
  "block.minecraft.chorus_flower": "Kwiat refrenusu",
  "block.minecraft.chorus_plant": "Łodyga refrenusu",
  "block.minecraft.clay": "Glina",
  "block.minecraft.closed_eyeblossom": "Zamknięta okrotka",
  "block.minecraft.coal_block": "Blok węgla",
  "block.minecraft.coal_ore": "Złoże węgla",
  "block.minecraft.coarse_dirt": "Twarda ziemia",
  "block.minecraft.cobbled_deepslate": "Łupkowy bruk",
  "block.minecraft.cobbled_deepslate_slab": "Łupkowa brukowa płyta",
  "block.minecraft.cobbled_deepslate_stairs": "Łupkowe brukowe schody",
  "block.minecraft.cobbled_deepslate_wall": "Łupkowy brukowy murek",
  "block.minecraft.cobblestone": "Bruk",
  "block.minecraft.cobblestone_slab": "Brukowa płyta",
  "block.minecraft.cobblestone_stairs": "Brukowe schody",
  "block.minecraft.cobblestone_wall": "Brukowy murek",
  "block.minecraft.cobweb": "Pajęczyna",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Blok poleceń",
  "block.minecraft.comparator": "Komparator redstone",
  "block.minecraft.composter": "Kompostownik",
  "block.minecraft.conduit": "Przewodnia",
  "block.minecraft.copper_bars": "Miedziane kraty",
  "block.minecraft.copper_block": "Blok miedzi",
  "block.minecraft.copper_bulb": "Miedziana lampa",
  "block.minecraft.copper_chain": "Miedziany łańcuch",
  "block.minecraft.copper_chest": "Miedziana skrzynia",
  "block.minecraft.copper_door": "Miedziane drzwi",
  "block.minecraft.copper_golem_statue": "Posąg miedzianego golema",
  "block.minecraft.copper_grate": "Miedziana krata",
  "block.minecraft.copper_lantern": "Miedziana latarnia",
  "block.minecraft.copper_ore": "Złoże miedzi",
  "block.minecraft.copper_torch": "Miedziowa pochodnia",
  "block.minecraft.copper_trapdoor": "Miedziana klapa",
  "block.minecraft.copper_wall_torch": "Ścienna miedziowa pochodnia",
  "block.minecraft.cornflower": "Chaber",
  "block.minecraft.cracked_deepslate_bricks": "Popękane łupkowe cegły",
  "block.minecraft.cracked_deepslate_tiles": "Popękane łupkowe kafelki",
  "block.minecraft.cracked_nether_bricks": "Popękane netherowe cegły",
  "block.minecraft.cracked_polished_blackstone_bricks": "Popękane wypolerowane czernitowe cegły",
  "block.minecraft.cracked_stone_bricks": "Popękane kamienne cegły",
  "block.minecraft.crafter": "Wytwarzacz",
  "block.minecraft.crafting_table": "Stół rzemieślniczy",
  "block.minecraft.creaking_heart": "Trzeszczące serce",
  "block.minecraft.creeper_head": "Głowa creepera",
  "block.minecraft.creeper_wall_head": "Ścienna głowa creepera",
  "block.minecraft.crimson_button": "Szkarłatny przycisk",
  "block.minecraft.crimson_door": "Szkarłatne drzwi",
  "block.minecraft.crimson_fence": "Szkarłatny płot",
  "block.minecraft.crimson_fence_gate": "Szkarłatna furtka",
  "block.minecraft.crimson_fungus": "Szkarłatny grzyb",
  "block.minecraft.crimson_hanging_sign": "Szkarłatna podwieszana tabliczka",
  "block.minecraft.crimson_hyphae": "Szkarłatne strzępki",
  "block.minecraft.crimson_nylium": "Szkarłatne nylium",
  "block.minecraft.crimson_planks": "Szkarłatne deski",
  "block.minecraft.crimson_pressure_plate": "Szkarłatna płytka naciskowa",
  "block.minecraft.crimson_roots": "Szkarłatne korzenie",
  "block.minecraft.crimson_shelf": "Szkarłatna półka",
  "block.minecraft.crimson_sign": "Szkarłatna tabliczka",
  "block.minecraft.crimson_slab": "Szkarłatna płyta",
  "block.minecraft.crimson_stairs": "Szkarłatne schody",
  "block.minecraft.crimson_stem": "Szkarłatny trzon",
  "block.minecraft.crimson_trapdoor": "Szkarłatna klapa",
  "block.minecraft.crimson_wall_hanging_sign": "Szkarłatna ścienna podwieszana tabliczka",
  "block.minecraft.crimson_wall_sign": "Szkarłatna ścienna tabliczka",
  "block.minecraft.crying_obsidian": "Płaczący obsydian",
  "block.minecraft.cut_copper": "Żłobiona miedź",
  "block.minecraft.cut_copper_slab": "Żłobiona miedziana płyta",
  "block.minecraft.cut_copper_stairs": "Żłobione miedziane schody",
  "block.minecraft.cut_red_sandstone": "Przycięty czerwony piaskowiec",
  "block.minecraft.cut_red_sandstone_slab": "Przycięta czerwona piaskowcowa płyta",
  "block.minecraft.cut_sandstone": "Przycięty piaskowiec",
  "block.minecraft.cut_sandstone_slab": "Przycięta piaskowcowa płyta",
  "block.minecraft.cyan_banner": "Błękitny sztandar",
  "block.minecraft.cyan_bed": "Błękitne łóżko",
  "block.minecraft.cyan_candle": "Błękitna świeca",
  "block.minecraft.cyan_candle_cake": "Ciasto z błękitną świeczką",
  "block.minecraft.cyan_carpet": "Błękitny dywan",
  "block.minecraft.cyan_concrete": "Błękitny beton",
  "block.minecraft.cyan_concrete_powder": "Błękitny cement",
  "block.minecraft.cyan_glazed_terracotta": "Błękitna glazurowana terakota",
  "block.minecraft.cyan_shulker_box": "Błękitna shulkerowa skrzynia",
  "block.minecraft.cyan_stained_glass": "Błękitne szkło",
  "block.minecraft.cyan_stained_glass_pane": "Błękitna szyba",
  "block.minecraft.cyan_terracotta": "Błękitna terakota",
  "block.minecraft.cyan_wool": "Błękitna wełna",
  "block.minecraft.damaged_anvil": "Uszkodzone kowadło",
  "block.minecraft.dandelion": "Mlecz",
  "block.minecraft.dark_oak_button": "Ciemnodębowy przycisk",
  "block.minecraft.dark_oak_door": "Ciemnodębowe drzwi",
  "block.minecraft.dark_oak_fence": "Ciemnodębowy płot",
  "block.minecraft.dark_oak_fence_gate": "Ciemnodębowa furtka",
  "block.minecraft.dark_oak_hanging_sign": "Ciemnodębowa podwieszana tabliczka",
  "block.minecraft.dark_oak_leaves": "Ciemnodębowe liście",
  "block.minecraft.dark_oak_log": "Ciemnodębowy pień",
  "block.minecraft.dark_oak_planks": "Ciemnodębowe deski",
  "block.minecraft.dark_oak_pressure_plate": "Ciemnodębowa płytka naciskowa",
  "block.minecraft.dark_oak_sapling": "Sadzonka ciemnego dębu",
  "block.minecraft.dark_oak_shelf": "Ciemnodębowa półka",
  "block.minecraft.dark_oak_sign": "Ciemnodębowa tabliczka",
  "block.minecraft.dark_oak_slab": "Ciemnodębowa płyta",
  "block.minecraft.dark_oak_stairs": "Ciemnodębowe schody",
  "block.minecraft.dark_oak_trapdoor": "Ciemnodębowa klapa",
  "block.minecraft.dark_oak_wall_hanging_sign": "Ciemnodębowa ścienna podwieszana tabliczka",
  "block.minecraft.dark_oak_wall_sign": "Ciemnodębowa ścienna tabliczka",
  "block.minecraft.dark_oak_wood": "Ciemnodębowe drewno",
  "block.minecraft.dark_prismarine": "Ciemny pryzmaryn",
  "block.minecraft.dark_prismarine_slab": "Ciemna pryzmarynowa płyta",
  "block.minecraft.dark_prismarine_stairs": "Ciemne pryzmarynowe schody",
  "block.minecraft.daylight_detector": "Detektor światła dziennego",
  "block.minecraft.dead_brain_coral": "Martwy koralowiec mózgowaty",
  "block.minecraft.dead_brain_coral_block": "Blok martwego koralowca mózgowatego",
  "block.minecraft.dead_brain_coral_fan": "Martwy wachlarz koralowca mózgowatego",
  "block.minecraft.dead_brain_coral_wall_fan": "Martwy wachlarz naścienny koralowca mózgowatego",
  "block.minecraft.dead_bubble_coral": "Martwy koralowiec bąbelkowy",
  "block.minecraft.dead_bubble_coral_block": "Blok martwego koralowca bąbelkowatego",
  "block.minecraft.dead_bubble_coral_fan": "Martwy wachlarz koralowca bąbelkowatego",
  "block.minecraft.dead_bubble_coral_wall_fan": "Martwy wachlarz naścienny koralowca bąbelkowatego",
  "block.minecraft.dead_bush": "Uschnięty krzak",
  "block.minecraft.dead_fire_coral": "Martwy koralowiec ognisty",
  "block.minecraft.dead_fire_coral_block": "Blok martwego koralowca ognistego",
  "block.minecraft.dead_fire_coral_fan": "Martwy wachlarz koralowca ognistego",
  "block.minecraft.dead_fire_coral_wall_fan": "Martwy wachlarz naścienny koralowca ognistego",
  "block.minecraft.dead_horn_coral": "Martwy koralowiec rogaty",
  "block.minecraft.dead_horn_coral_block": "Blok martwego koralowca rogatego",
  "block.minecraft.dead_horn_coral_fan": "Martwy wachlarz koralowca rogatego",
  "block.minecraft.dead_horn_coral_wall_fan": "Martwy wachlarz naścienny koralowca rogatego",
  "block.minecraft.dead_tube_coral": "Martwy koralowiec rurkowaty",
  "block.minecraft.dead_tube_coral_block": "Blok martwego koralowca rurkowatego",
  "block.minecraft.dead_tube_coral_fan": "Martwy wachlarz koralowca rurkowatego",
  "block.minecraft.dead_tube_coral_wall_fan": "Martwy wachlarz naścienny koralowca rurkowatego",
  "block.minecraft.decorated_pot": "Dekorowany garniec",
  "block.minecraft.deepslate": "Łupek",
  "block.minecraft.deepslate_brick_slab": "Łupkowa ceglana płyta",
  "block.minecraft.deepslate_brick_stairs": "Łupkowe ceglane schody",
  "block.minecraft.deepslate_brick_wall": "Łupkowy ceglany murek",
  "block.minecraft.deepslate_bricks": "Łupkowe cegły",
  "block.minecraft.deepslate_coal_ore": "Łupkowe złoże węgla",
  "block.minecraft.deepslate_copper_ore": "Łupkowe złoże miedzi",
  "block.minecraft.deepslate_diamond_ore": "Łupkowe złoże diamentu",
  "block.minecraft.deepslate_emerald_ore": "Łupkowe złoże szmaragdu",
  "block.minecraft.deepslate_gold_ore": "Łupkowe złoże złota",
  "block.minecraft.deepslate_iron_ore": "Łupkowe złoże żelaza",
  "block.minecraft.deepslate_lapis_ore": "Łupkowe złoże lazurytu",
  "block.minecraft.deepslate_redstone_ore": "Łupkowe złoże redstone",
  "block.minecraft.deepslate_tile_slab": "Łupkowa kafelkowa płyta",
  "block.minecraft.deepslate_tile_stairs": "Łupkowe kafelkowe schody",
  "block.minecraft.deepslate_tile_wall": "Łupkowy kafelkowy murek",
  "block.minecraft.deepslate_tiles": "Łupkowe kafelki",
  "block.minecraft.detector_rail": "Tory z czujnikiem",
  "block.minecraft.diamond_block": "Blok diamentu",
  "block.minecraft.diamond_ore": "Złoże diamentu",
  "block.minecraft.diorite": "Dioryt",
  "block.minecraft.diorite_slab": "Diorytowa płyta",
  "block.minecraft.diorite_stairs": "Diorytowe schody",
  "block.minecraft.diorite_wall": "Diorytowy murek",
  "block.minecraft.dirt": "Ziemia",
  "block.minecraft.dirt_path": "Ścieżka",
  "block.minecraft.dispenser": "Dozownik",
  "block.minecraft.dragon_egg": "Smocze jajo",
  "block.minecraft.dragon_head": "Głowa smoka",
  "block.minecraft.dragon_wall_head": "Ścienna głowa smoka",
  "block.minecraft.dried_ghast": "Wyschnięty ghast",
  "block.minecraft.dried_kelp_block": "Blok suszonych wodorostów",
  "block.minecraft.dripstone_block": "Blok nacieku",
  "block.minecraft.dropper": "Podajnik",
  "block.minecraft.emerald_block": "Blok szmaragdu",
  "block.minecraft.emerald_ore": "Złoże szmaragdu",
  "block.minecraft.enchanting_table": "Stół do zaklinania",
  "block.minecraft.end_gateway": "Brama Endu",
  "block.minecraft.end_portal": "Portal do Endu",
  "block.minecraft.end_portal_frame": "Rama portalu do Endu",
  "block.minecraft.end_rod": "Endowy słupek",
  "block.minecraft.end_stone": "Kamień Endu",
  "block.minecraft.end_stone_brick_slab": "Endowa kamienna ceglana płyta",
  "block.minecraft.end_stone_brick_stairs": "Endowe kamienne ceglane schody",
  "block.minecraft.end_stone_brick_wall": "Endowy kamienny ceglany murek",
  "block.minecraft.end_stone_bricks": "Endowe kamienne cegły",
  "block.minecraft.ender_chest": "Skrzynia Endu",
  "block.minecraft.exposed_chiseled_copper": "Zwietrzała rzeźbiona miedź",
  "block.minecraft.exposed_copper": "Zwietrzała miedź",
  "block.minecraft.exposed_copper_bars": "Zwietrzałe miedziane kraty",
  "block.minecraft.exposed_copper_bulb": "Zwietrzała miedziana lampa",
  "block.minecraft.exposed_copper_chain": "Zwietrzały miedziany łańcuch",
  "block.minecraft.exposed_copper_chest": "Zwietrzała miedziana skrzynia",
  "block.minecraft.exposed_copper_door": "Zwietrzałe miedziane drzwi",
  "block.minecraft.exposed_copper_golem_statue": "Zwietrzały posąg miedzianego golema",
  "block.minecraft.exposed_copper_grate": "Zwietrzała miedziana krata",
  "block.minecraft.exposed_copper_lantern": "Zwietrzała miedziana latarnia",
  "block.minecraft.exposed_copper_trapdoor": "Zwietrzała miedziana klapa",
  "block.minecraft.exposed_cut_copper": "Zwietrzała żłobiona miedź",
  "block.minecraft.exposed_cut_copper_slab": "Zwietrzała żłobiona miedziana płyta",
  "block.minecraft.exposed_cut_copper_stairs": "Zwietrzałe żłobione miedziane schody",
  "block.minecraft.exposed_lightning_rod": "Zwietrzały piorunochron",
  "block.minecraft.farmland": "Pole uprawne",
  "block.minecraft.fern": "Paproć",
  "block.minecraft.fire": "Ogień",
  "block.minecraft.fire_coral": "Koralowiec ognisty",
  "block.minecraft.fire_coral_block": "Blok koralowca ognistego",
  "block.minecraft.fire_coral_fan": "Wachlarz koralowca ognistego",
  "block.minecraft.fire_coral_wall_fan": "Wachlarz naścienny koralowca ognistego",
  "block.minecraft.firefly_bush": "Krzew świetlików",
  "block.minecraft.fletching_table": "Stół łuczarski",
  "block.minecraft.flower_pot": "Doniczka",
  "block.minecraft.flowering_azalea": "Kwitnąca azalia",
  "block.minecraft.flowering_azalea_leaves": "Kwitnące liście azalii",
  "block.minecraft.frogspawn": "Żabi skrzek",
  "block.minecraft.frosted_ice": "Oszroniony lód",
  "block.minecraft.furnace": "Piec",
  "block.minecraft.gilded_blackstone": "Złocony czernit",
  "block.minecraft.glass": "Szkło",
  "block.minecraft.glass_pane": "Szyba",
  "block.minecraft.glow_lichen": "Świecący porost",
  "block.minecraft.glowstone": "Jasnogłaz",
  "block.minecraft.gold_block": "Blok złota",
  "block.minecraft.gold_ore": "Złoże złota",
  "block.minecraft.golden_dandelion": "Złoty mlecz",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitowa płyta",
  "block.minecraft.granite_stairs": "Granitowe schody",
  "block.minecraft.granite_wall": "Granitowy murek",
  "block.minecraft.grass": "Trawa",
  "block.minecraft.grass_block": "Blok trawy",
  "block.minecraft.gravel": "Żwir",
  "block.minecraft.gray_banner": "Szary sztandar",
  "block.minecraft.gray_bed": "Szare łóżko",
  "block.minecraft.gray_candle": "Szara świeca",
  "block.minecraft.gray_candle_cake": "Ciasto z szarą świeczką",
  "block.minecraft.gray_carpet": "Szary dywan",
  "block.minecraft.gray_concrete": "Szary beton",
  "block.minecraft.gray_concrete_powder": "Szary cement",
  "block.minecraft.gray_glazed_terracotta": "Szara glazurowana terakota",
  "block.minecraft.gray_shulker_box": "Szara shulkerowa skrzynia",
  "block.minecraft.gray_stained_glass": "Szare szkło",
  "block.minecraft.gray_stained_glass_pane": "Szara szyba",
  "block.minecraft.gray_terracotta": "Szara terakota",
  "block.minecraft.gray_wool": "Szara wełna",
  "block.minecraft.green_banner": "Zielony sztandar",
  "block.minecraft.green_bed": "Zielone łóżko",
  "block.minecraft.green_candle": "Zielona świeca",
  "block.minecraft.green_candle_cake": "Ciasto z zieloną świeczką",
  "block.minecraft.green_carpet": "Zielony dywan",
  "block.minecraft.green_concrete": "Zielony beton",
  "block.minecraft.green_concrete_powder": "Zielony cement",
  "block.minecraft.green_glazed_terracotta": "Zielona glazurowana terakota",
  "block.minecraft.green_shulker_box": "Zielona shulkerowa skrzynia",
  "block.minecraft.green_stained_glass": "Zielone szkło",
  "block.minecraft.green_stained_glass_pane": "Zielona szyba",
  "block.minecraft.green_terracotta": "Zielona terakota",
  "block.minecraft.green_wool": "Zielona wełna",
  "block.minecraft.grindstone": "Kamień szlifierski",
  "block.minecraft.hanging_roots": "Zwisające korzenie",
  "block.minecraft.hay_block": "Snop siana",
  "block.minecraft.heavy_core": "Ciężki rdzeń",
  "block.minecraft.heavy_weighted_pressure_plate": "Ciężka wagowa płytka naciskowa",
  "block.minecraft.honey_block": "Blok miodu",
  "block.minecraft.honeycomb_block": "Blok plastra miodu",
  "block.minecraft.hopper": "Lej",
  "block.minecraft.horn_coral": "Koralowiec rogaty",
  "block.minecraft.horn_coral_block": "Blok koralowca rogatego",
  "block.minecraft.horn_coral_fan": "Wachlarz koralowca rogatego",
  "block.minecraft.horn_coral_wall_fan": "Wachlarz naścienny koralowca rogatego",
  "block.minecraft.ice": "Lód",
  "block.minecraft.infested_chiseled_stone_bricks": "Zarobaczone rzeźbione kamienne cegły",
  "block.minecraft.infested_cobblestone": "Zarobaczony bruk",
  "block.minecraft.infested_cracked_stone_bricks": "Zarobaczone popękane kamienne cegły",
  "block.minecraft.infested_deepslate": "Zarobaczony łupek",
  "block.minecraft.infested_mossy_stone_bricks": "Zarobaczone zamszone kamienne cegły",
  "block.minecraft.infested_stone": "Zarobaczony kamień",
  "block.minecraft.infested_stone_bricks": "Zarobaczone kamienne cegły",
  "block.minecraft.iron_bars": "Żelazne kraty",
  "block.minecraft.iron_block": "Blok żelaza",
  "block.minecraft.iron_chain": "Żelazny łańcuch",
  "block.minecraft.iron_door": "Żelazne drzwi",
  "block.minecraft.iron_ore": "Złoże żelaza",
  "block.minecraft.iron_trapdoor": "Żelazna klapa",
  "block.minecraft.jack_o_lantern": "Latarnia dyniowa",
  "block.minecraft.jigsaw": "Blok konstrukcyjny",
  "block.minecraft.jukebox": "Szafa grająca",
  "block.minecraft.jungle_button": "Tropikalny przycisk",
  "block.minecraft.jungle_door": "Tropikalne drzwi",
  "block.minecraft.jungle_fence": "Tropikalny płot",
  "block.minecraft.jungle_fence_gate": "Tropikalna furtka",
  "block.minecraft.jungle_hanging_sign": "Tropikalna podwieszana tabliczka",
  "block.minecraft.jungle_leaves": "Tropikalne liście",
  "block.minecraft.jungle_log": "Tropikalny pień",
  "block.minecraft.jungle_planks": "Tropikalne deski",
  "block.minecraft.jungle_pressure_plate": "Tropikalna płytka naciskowa",
  "block.minecraft.jungle_sapling": "Sadzonka tropikalna",
  "block.minecraft.jungle_shelf": "Tropikalna półka",
  "block.minecraft.jungle_sign": "Tropikalna tabliczka",
  "block.minecraft.jungle_slab": "Tropikalna płyta",
  "block.minecraft.jungle_stairs": "Tropikalne schody",
  "block.minecraft.jungle_trapdoor": "Tropikalna klapa",
  "block.minecraft.jungle_wall_hanging_sign": "Tropikalna ścienna podwieszana tabliczka",
  "block.minecraft.jungle_wall_sign": "Tropikalna ścienna tabliczka",
  "block.minecraft.jungle_wood": "Tropikalne drewno",
  "block.minecraft.kelp": "Wodorost",
  "block.minecraft.kelp_plant": "Rosnące wodorosty",
  "block.minecraft.ladder": "Drabina",
  "block.minecraft.lantern": "Latarnia",
  "block.minecraft.lapis_block": "Blok lazurytu",
  "block.minecraft.lapis_ore": "Złoże lazurytu",
  "block.minecraft.large_amethyst_bud": "Duży zarodek ametystu",
  "block.minecraft.large_fern": "Duża paproć",
  "block.minecraft.lava": "Lawa",
  "block.minecraft.lava_cauldron": "Kocioł lawy",
  "block.minecraft.leaf_litter": "Ściółka",
  "block.minecraft.lectern": "Pulpit",
  "block.minecraft.lever": "Dźwignia",
  "block.minecraft.light": "Światło",
  "block.minecraft.light_blue_banner": "Jasnoniebieski sztandar",
  "block.minecraft.light_blue_bed": "Jasnoniebieskie łóżko",
  "block.minecraft.light_blue_candle": "Jasnoniebieska świeca",
  "block.minecraft.light_blue_candle_cake": "Ciasto z jasnoniebieską świeczką",
  "block.minecraft.light_blue_carpet": "Jasnoniebieski dywan",
  "block.minecraft.light_blue_concrete": "Jasnoniebieski beton",
  "block.minecraft.light_blue_concrete_powder": "Jasnoniebieski cement",
  "block.minecraft.light_blue_glazed_terracotta": "Jasnoniebieska glazurowana terakota",
  "block.minecraft.light_blue_shulker_box": "Jasnoniebieska shulkerowa skrzynia",
  "block.minecraft.light_blue_stained_glass": "Jasnoniebieskie szkło",
  "block.minecraft.light_blue_stained_glass_pane": "Jasnoniebieska szyba",
  "block.minecraft.light_blue_terracotta": "Jasnoniebieska terakota",
  "block.minecraft.light_blue_wool": "Jasnoniebieska wełna",
  "block.minecraft.light_gray_banner": "Jasnoszary sztandar",
  "block.minecraft.light_gray_bed": "Jasnoszare łóżko",
  "block.minecraft.light_gray_candle": "Jasnoszara świeca",
  "block.minecraft.light_gray_candle_cake": "Ciasto z jasnoszarą świeczką",
  "block.minecraft.light_gray_carpet": "Jasnoszary dywan",
  "block.minecraft.light_gray_concrete": "Jasnoszary beton",
  "block.minecraft.light_gray_concrete_powder": "Jasnoszary cement",
  "block.minecraft.light_gray_glazed_terracotta": "Jasnoszara glazurowana terakota",
  "block.minecraft.light_gray_shulker_box": "Jasnoszara shulkerowa skrzynia",
  "block.minecraft.light_gray_stained_glass": "Jasnoszare szkło",
  "block.minecraft.light_gray_stained_glass_pane": "Jasnoszara szyba",
  "block.minecraft.light_gray_terracotta": "Jasnoszara terakota",
  "block.minecraft.light_gray_wool": "Jasnoszara wełna",
  "block.minecraft.light_weighted_pressure_plate": "Lekka wagowa płytka naciskowa",
  "block.minecraft.lightning_rod": "Piorunochron",
  "block.minecraft.lilac": "Bez",
  "block.minecraft.lily_of_the_valley": "Konwalia",
  "block.minecraft.lily_pad": "Lilia wodna",
  "block.minecraft.lime_banner": "Jasnozielony sztandar",
  "block.minecraft.lime_bed": "Jasnozielone łóżko",
  "block.minecraft.lime_candle": "Jasnozielona świeca",
  "block.minecraft.lime_candle_cake": "Ciasto z jasnozieloną świeczką",
  "block.minecraft.lime_carpet": "Jasnozielony dywan",
  "block.minecraft.lime_concrete": "Jasnozielony beton",
  "block.minecraft.lime_concrete_powder": "Jasnozielony cement",
  "block.minecraft.lime_glazed_terracotta": "Jasnozielona glazurowana terakota",
  "block.minecraft.lime_shulker_box": "Jasnozielona shulkerowa skrzynia",
  "block.minecraft.lime_stained_glass": "Jasnozielone szkło",
  "block.minecraft.lime_stained_glass_pane": "Jasnozielona szyba",
  "block.minecraft.lime_terracotta": "Jasnozielona terakota",
  "block.minecraft.lime_wool": "Jasnozielona wełna",
  "block.minecraft.lodestone": "Magnetyt",
  "block.minecraft.loom": "Krosno",
  "block.minecraft.magenta_banner": "Purpurowy sztandar",
  "block.minecraft.magenta_bed": "Purpurowe łóżko",
  "block.minecraft.magenta_candle": "Purpurowa świeca",
  "block.minecraft.magenta_candle_cake": "Ciasto z purpurową świeczką",
  "block.minecraft.magenta_carpet": "Purpurowy dywan",
  "block.minecraft.magenta_concrete": "Purpurowy beton",
  "block.minecraft.magenta_concrete_powder": "Purpurowy cement",
  "block.minecraft.magenta_glazed_terracotta": "Purpurowa glazurowana terakota",
  "block.minecraft.magenta_shulker_box": "Purpurowa shulkerowa skrzynia",
  "block.minecraft.magenta_stained_glass": "Purpurowe szkło",
  "block.minecraft.magenta_stained_glass_pane": "Purpurowa szyba",
  "block.minecraft.magenta_terracotta": "Purpurowa terakota",
  "block.minecraft.magenta_wool": "Purpurowa wełna",
  "block.minecraft.magma_block": "Blok magmy",
  "block.minecraft.mangrove_button": "Namorzynowy przycisk",
  "block.minecraft.mangrove_door": "Namorzynowe drzwi",
  "block.minecraft.mangrove_fence": "Namorzynowy płot",
  "block.minecraft.mangrove_fence_gate": "Namorzynowa furtka",
  "block.minecraft.mangrove_hanging_sign": "Namorzynowa podwieszana tabliczka",
  "block.minecraft.mangrove_leaves": "Namorzynowe liście",
  "block.minecraft.mangrove_log": "Namorzynowy pień",
  "block.minecraft.mangrove_planks": "Namorzynowe deski",
  "block.minecraft.mangrove_pressure_plate": "Namorzynowa płytka naciskowa",
  "block.minecraft.mangrove_propagule": "Siewka namorzynu",
  "block.minecraft.mangrove_roots": "Namorzynowe korzenie",
  "block.minecraft.mangrove_shelf": "Namorzynowa półka",
  "block.minecraft.mangrove_sign": "Namorzynowa tabliczka",
  "block.minecraft.mangrove_slab": "Namorzynowa płyta",
  "block.minecraft.mangrove_stairs": "Namorzynowe schody",
  "block.minecraft.mangrove_trapdoor": "Namorzynowa klapa",
  "block.minecraft.mangrove_wall_hanging_sign": "Namorzynowa ścienna podwieszana tabliczka",
  "block.minecraft.mangrove_wall_sign": "Namorzynowa ścienna tabliczka",
  "block.minecraft.mangrove_wood": "Namorzynowe drewno",
  "block.minecraft.medium_amethyst_bud": "Średni zarodek ametystu",
  "block.minecraft.melon": "Arbuz",
  "block.minecraft.melon_stem": "Łodyga arbuza",
  "block.minecraft.moss_block": "Blok mchu",
  "block.minecraft.moss_carpet": "Warstwa mchu",
  "block.minecraft.mossy_cobblestone": "Zamszony bruk",
  "block.minecraft.mossy_cobblestone_slab": "Zamszona brukowa płyta",
  "block.minecraft.mossy_cobblestone_stairs": "Zamszone brukowe schody",
  "block.minecraft.mossy_cobblestone_wall": "Zamszony brukowy murek",
  "block.minecraft.mossy_stone_brick_slab": "Zamszona kamienna ceglana płyta",
  "block.minecraft.mossy_stone_brick_stairs": "Zamszone kamienne ceglane schody",
  "block.minecraft.mossy_stone_brick_wall": "Zamszony kamienny ceglany murek",
  "block.minecraft.mossy_stone_bricks": "Zamszone kamienne cegły",
  "block.minecraft.moving_piston": "Poruszany blok",
  "block.minecraft.mud": "Błoto",
  "block.minecraft.mud_brick_slab": "Błotna ceglana płyta",
  "block.minecraft.mud_brick_stairs": "Błotne ceglane schody",
  "block.minecraft.mud_brick_wall": "Błotny ceglany murek",
  "block.minecraft.mud_bricks": "Błotne cegły",
  "block.minecraft.muddy_mangrove_roots": "Zabłocone namorzynowe korzenie",
  "block.minecraft.mushroom_stem": "Trzon grzyba",
  "block.minecraft.mycelium": "Grzybnia",
  "block.minecraft.nether_brick_fence": "Netherowy ceglany płot",
  "block.minecraft.nether_brick_slab": "Netherowa ceglana płyta",
  "block.minecraft.nether_brick_stairs": "Netherowe ceglane schody",
  "block.minecraft.nether_brick_wall": "Netherowy ceglany murek",
  "block.minecraft.nether_bricks": "Netherowe cegły",
  "block.minecraft.nether_gold_ore": "Netherowe złoże złota",
  "block.minecraft.nether_portal": "Netherowy portal",
  "block.minecraft.nether_quartz_ore": "Złoże netherowego kwarcu",
  "block.minecraft.nether_sprouts": "Netherowe kiełki",
  "block.minecraft.nether_wart": "Netherowa brodawka",
  "block.minecraft.nether_wart_block": "Blok netherowych brodawek",
  "block.minecraft.netherite_block": "Blok netherytu",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Blok dźwiękowy",
  "block.minecraft.oak_button": "Dębowy przycisk",
  "block.minecraft.oak_door": "Dębowe drzwi",
  "block.minecraft.oak_fence": "Dębowy płot",
  "block.minecraft.oak_fence_gate": "Dębowa furtka",
  "block.minecraft.oak_hanging_sign": "Dębowa podwieszana tabliczka",
  "block.minecraft.oak_leaves": "Dębowe liście",
  "block.minecraft.oak_log": "Dębowy pień",
  "block.minecraft.oak_planks": "Dębowe deski",
  "block.minecraft.oak_pressure_plate": "Dębowa płytka naciskowa",
  "block.minecraft.oak_sapling": "Sadzonka dębu",
  "block.minecraft.oak_shelf": "Dębowa półka",
  "block.minecraft.oak_sign": "Dębowa tabliczka",
  "block.minecraft.oak_slab": "Dębowa płyta",
  "block.minecraft.oak_stairs": "Dębowe schody",
  "block.minecraft.oak_trapdoor": "Dębowa klapa",
  "block.minecraft.oak_wall_hanging_sign": "Dębowa ścienna podwieszana tabliczka",
  "block.minecraft.oak_wall_sign": "Dębowa ścienna tabliczka",
  "block.minecraft.oak_wood": "Dębowe drewno",
  "block.minecraft.observer": "Detektor",
  "block.minecraft.obsidian": "Obsydian",
  "block.minecraft.ochre_froglight": "Złocista żabia lampa",
  "block.minecraft.ominous_banner": "Złowieszczy sztandar",
  "block.minecraft.open_eyeblossom": "Otwarta okrotka",
  "block.minecraft.orange_banner": "Pomarańczowy sztandar",
  "block.minecraft.orange_bed": "Pomarańczowe łóżko",
  "block.minecraft.orange_candle": "Pomarańczowa świeca",
  "block.minecraft.orange_candle_cake": "Ciasto z pomarańczową świeczką",
  "block.minecraft.orange_carpet": "Pomarańczowy dywan",
  "block.minecraft.orange_concrete": "Pomarańczowy beton",
  "block.minecraft.orange_concrete_powder": "Pomarańczowy cement",
  "block.minecraft.orange_glazed_terracotta": "Pomarańczowa glazurowana terakota",
  "block.minecraft.orange_shulker_box": "Pomarańczowa shulkerowa skrzynia",
  "block.minecraft.orange_stained_glass": "Pomarańczowe szkło",
  "block.minecraft.orange_stained_glass_pane": "Pomarańczowa szyba",
  "block.minecraft.orange_terracotta": "Pomarańczowa terakota",
  "block.minecraft.orange_tulip": "Pomarańczowy tulipan",
  "block.minecraft.orange_wool": "Pomarańczowa wełna",
  "block.minecraft.oxeye_daisy": "Margaretka",
  "block.minecraft.oxidized_chiseled_copper": "Utleniona rzeźbiona miedź",
  "block.minecraft.oxidized_copper": "Utleniona miedź",
  "block.minecraft.oxidized_copper_bars": "Utlenione miedziane kraty",
  "block.minecraft.oxidized_copper_bulb": "Utleniona miedziana lampa",
  "block.minecraft.oxidized_copper_chain": "Utleniony miedziany łańcuch",
  "block.minecraft.oxidized_copper_chest": "Utleniona miedziana skrzynia",
  "block.minecraft.oxidized_copper_door": "Utlenione miedziane drzwi",
  "block.minecraft.oxidized_copper_golem_statue": "Utleniony posąg miedzianego golema",
  "block.minecraft.oxidized_copper_grate": "Utleniona miedziana krata",
  "block.minecraft.oxidized_copper_lantern": "Utleniona miedziana latarnia",
  "block.minecraft.oxidized_copper_trapdoor": "Utleniona miedziana klapa",
  "block.minecraft.oxidized_cut_copper": "Utleniona żłobiona miedź",
  "block.minecraft.oxidized_cut_copper_slab": "Utleniona żłobiona miedziana płyta",
  "block.minecraft.oxidized_cut_copper_stairs": "Utlenione żłobione miedziane schody",
  "block.minecraft.oxidized_lightning_rod": "Utleniony piorunochron",
  "block.minecraft.packed_ice": "Zbity lód",
  "block.minecraft.packed_mud": "Utwardzone błoto",
  "block.minecraft.pale_hanging_moss": "Zwisający blady mech",
  "block.minecraft.pale_moss_block": "Blok bladego mchu",
  "block.minecraft.pale_moss_carpet": "Warstwa bladego mchu",
  "block.minecraft.pale_oak_button": "Bladodębowy przycisk",
  "block.minecraft.pale_oak_door": "Bladodębowe drzwi",
  "block.minecraft.pale_oak_fence": "Bladodębowy płot",
  "block.minecraft.pale_oak_fence_gate": "Bladodębowa furtka",
  "block.minecraft.pale_oak_hanging_sign": "Bladodębowa podwieszana tabliczka",
  "block.minecraft.pale_oak_leaves": "Bladodębowe liście",
  "block.minecraft.pale_oak_log": "Bladodębowy pień",
  "block.minecraft.pale_oak_planks": "Bladodębowe deski",
  "block.minecraft.pale_oak_pressure_plate": "Bladodębowa płytka naciskowa",
  "block.minecraft.pale_oak_sapling": "Sadzonka bladego dębu",
  "block.minecraft.pale_oak_shelf": "Bladodębowa półka",
  "block.minecraft.pale_oak_sign": "Bladodębowa tabliczka",
  "block.minecraft.pale_oak_slab": "Bladodębowa płyta",
  "block.minecraft.pale_oak_stairs": "Bladodębowe schody",
  "block.minecraft.pale_oak_trapdoor": "Bladodębowa klapa",
  "block.minecraft.pale_oak_wall_hanging_sign": "Bladodębowa ścienna podwieszana tabliczka",
  "block.minecraft.pale_oak_wall_sign": "Bladodębowa ścienna tabliczka",
  "block.minecraft.pale_oak_wood": "Bladodębowe drewno",
  "block.minecraft.pearlescent_froglight": "Perłowa żabia lampa",
  "block.minecraft.peony": "Piwonia",
  "block.minecraft.petrified_oak_slab": "Skamieniała dębowa płyta",
  "block.minecraft.piglin_head": "Głowa piglina",
  "block.minecraft.piglin_wall_head": "Ścienna głowa piglina",
  "block.minecraft.pink_banner": "Różowy sztandar",
  "block.minecraft.pink_bed": "Różowe łóżko",
  "block.minecraft.pink_candle": "Różowa świeca",
  "block.minecraft.pink_candle_cake": "Ciasto z różową świeczką",
  "block.minecraft.pink_carpet": "Różowy dywan",
  "block.minecraft.pink_concrete": "Różowy beton",
  "block.minecraft.pink_concrete_powder": "Różowy cement",
  "block.minecraft.pink_glazed_terracotta": "Różowa glazurowana terakota",
  "block.minecraft.pink_petals": "Różowe kwiatki",
  "block.minecraft.pink_shulker_box": "Różowa shulkerowa skrzynia",
  "block.minecraft.pink_stained_glass": "Różowe szkło",
  "block.minecraft.pink_stained_glass_pane": "Różowa szyba",
  "block.minecraft.pink_terracotta": "Różowa terakota",
  "block.minecraft.pink_tulip": "Różowy tulipan",
  "block.minecraft.pink_wool": "Różowa wełna",
  "block.minecraft.piston": "Tłok",
  "block.minecraft.piston_head": "Głowica tłoka",
  "block.minecraft.pitcher_crop": "Plon dzbanecznika",
  "block.minecraft.pitcher_plant": "Dzbanecznik",
  "block.minecraft.player_head": "Głowa gracza",
  "block.minecraft.player_head.named": "Głowa gracza %s",
  "block.minecraft.player_wall_head": "Ścienna głowa gracza",
  "block.minecraft.podzol": "Bielica",
  "block.minecraft.pointed_dripstone": "Spiczasty naciek",
  "block.minecraft.polished_andesite": "Wypolerowany andezyt",
  "block.minecraft.polished_andesite_slab": "Wypolerowana andezytowa płyta",
  "block.minecraft.polished_andesite_stairs": "Wypolerowane andezytowe schody",
  "block.minecraft.polished_basalt": "Wypolerowany bazalt",
  "block.minecraft.polished_blackstone": "Wypolerowany czernit",
  "block.minecraft.polished_blackstone_brick_slab": "Wypolerowana czernitowa ceglana płyta",
  "block.minecraft.polished_blackstone_brick_stairs": "Wypolerowane czernitowe ceglane schody",
  "block.minecraft.polished_blackstone_brick_wall": "Wypolerowany czernitowy ceglany murek",
  "block.minecraft.polished_blackstone_bricks": "Wypolerowane czernitowe cegły",
  "block.minecraft.polished_blackstone_button": "Wypolerowany czernitowy przycisk",
  "block.minecraft.polished_blackstone_pressure_plate": "Wypolerowana czernitowa płytka naciskowa",
  "block.minecraft.polished_blackstone_slab": "Wypolerowana czernitowa płyta",
  "block.minecraft.polished_blackstone_stairs": "Wypolerowane czernitowe schody",
  "block.minecraft.polished_blackstone_wall": "Wypolerowany czernitowy murek",
  "block.minecraft.polished_deepslate": "Wypolerowany łupek",
  "block.minecraft.polished_deepslate_slab": "Wypolerowana łupkowa płyta",
  "block.minecraft.polished_deepslate_stairs": "Wypolerowane łupkowe schody",
  "block.minecraft.polished_deepslate_wall": "Wypolerowany łupkowy murek",
  "block.minecraft.polished_diorite": "Wypolerowany dioryt",
  "block.minecraft.polished_diorite_slab": "Wypolerowana diorytowa płyta",
  "block.minecraft.polished_diorite_stairs": "Wypolerowane diorytowe schody",
  "block.minecraft.polished_granite": "Wypolerowany granit",
  "block.minecraft.polished_granite_slab": "Wypolerowana granitowa płyta",
  "block.minecraft.polished_granite_stairs": "Wypolerowane granitowe schody",
  "block.minecraft.polished_tuff": "Wypolerowany tuf",
  "block.minecraft.polished_tuff_slab": "Wypolerowana tufowa płyta",
  "block.minecraft.polished_tuff_stairs": "Wypolerowane tufowe schody",
  "block.minecraft.polished_tuff_wall": "Wypolerowany tufowy murek",
  "block.minecraft.poppy": "Mak",
  "block.minecraft.potatoes": "Ziemniaki",
  "block.minecraft.potted_acacia_sapling": "Sadzonka akacji w doniczce",
  "block.minecraft.potted_allium": "Czosnek w doniczce",
  "block.minecraft.potted_azalea_bush": "Azalia w doniczce",
  "block.minecraft.potted_azure_bluet": "Houstonia błękitna w doniczce",
  "block.minecraft.potted_bamboo": "Bambus w doniczce",
  "block.minecraft.potted_birch_sapling": "Sadzonka brzozy w doniczce",
  "block.minecraft.potted_blue_orchid": "Niebieska orchidea w doniczce",
  "block.minecraft.potted_brown_mushroom": "Borowik w doniczce",
  "block.minecraft.potted_cactus": "Kaktus w doniczce",
  "block.minecraft.potted_cherry_sapling": "Sadzonka wiśni w doniczce",
  "block.minecraft.potted_closed_eyeblossom": "Zamknięta okrotka w doniczce",
  "block.minecraft.potted_cornflower": "Chaber w doniczce",
  "block.minecraft.potted_crimson_fungus": "Szkarłatny grzyb w doniczce",
  "block.minecraft.potted_crimson_roots": "Szkarłatne korzenie w doniczce",
  "block.minecraft.potted_dandelion": "Mlecz w doniczce",
  "block.minecraft.potted_dark_oak_sapling": "Sadzonka ciemnego dębu w doniczce",
  "block.minecraft.potted_dead_bush": "Uschnięty krzak w doniczce",
  "block.minecraft.potted_fern": "Paproć w doniczce",
  "block.minecraft.potted_flowering_azalea_bush": "Kwitnąca azalia w doniczce",
  "block.minecraft.potted_golden_dandelion": "Złoty mlecz w doniczce",
  "block.minecraft.potted_jungle_sapling": "Sadzonka tropikalna w doniczce",
  "block.minecraft.potted_lily_of_the_valley": "Konwalia w doniczce",
  "block.minecraft.potted_mangrove_propagule": "Siewka namorzynu w doniczce",
  "block.minecraft.potted_oak_sapling": "Sadzonka dębu w doniczce",
  "block.minecraft.potted_open_eyeblossom": "Otwarta okrotka w doniczce",
  "block.minecraft.potted_orange_tulip": "Pomarańczowy tulipan w doniczce",
  "block.minecraft.potted_oxeye_daisy": "Margaretka w doniczce",
  "block.minecraft.potted_pale_oak_sapling": "Sadzonka bladego dębu w doniczce",
  "block.minecraft.potted_pink_tulip": "Różowy tulipan w doniczce",
  "block.minecraft.potted_poppy": "Mak w doniczce",
  "block.minecraft.potted_red_mushroom": "Muchomor w doniczce",
  "block.minecraft.potted_red_tulip": "Czerwony tulipan w doniczce",
  "block.minecraft.potted_spruce_sapling": "Sadzonka świerku w doniczce",
  "block.minecraft.potted_torchflower": "Ognisty kwiat w doniczce",
  "block.minecraft.potted_warped_fungus": "Spaczony grzyb w doniczce",
  "block.minecraft.potted_warped_roots": "Spaczone korzenie w doniczce",
  "block.minecraft.potted_white_tulip": "Biały tulipan w doniczce",
  "block.minecraft.potted_wither_rose": "Witherowa róża w doniczce",
  "block.minecraft.powder_snow": "Sypki śnieg",
  "block.minecraft.powder_snow_cauldron": "Kocioł sypkiego śniegu",
  "block.minecraft.powered_rail": "Zasilane tory",
  "block.minecraft.prismarine": "Pryzmaryn",
  "block.minecraft.prismarine_brick_slab": "Pryzmarynowa ceglana płyta",
  "block.minecraft.prismarine_brick_stairs": "Pryzmarynowe ceglane schody",
  "block.minecraft.prismarine_bricks": "Pryzmarynowe cegły",
  "block.minecraft.prismarine_slab": "Pryzmarynowa płyta",
  "block.minecraft.prismarine_stairs": "Pryzmarynowe schody",
  "block.minecraft.prismarine_wall": "Pryzmarynowy murek",
  "block.minecraft.pumpkin": "Dynia",
  "block.minecraft.pumpkin_stem": "Łodyga dyni",
  "block.minecraft.purple_banner": "Fioletowy sztandar",
  "block.minecraft.purple_bed": "Fioletowe łóżko",
  "block.minecraft.purple_candle": "Fioletowa świeca",
  "block.minecraft.purple_candle_cake": "Ciasto z fioletową świeczką",
  "block.minecraft.purple_carpet": "Fioletowy dywan",
  "block.minecraft.purple_concrete": "Fioletowy beton",
  "block.minecraft.purple_concrete_powder": "Fioletowy cement",
  "block.minecraft.purple_glazed_terracotta": "Fioletowa glazurowana terakota",
  "block.minecraft.purple_shulker_box": "Fioletowa shulkerowa skrzynia",
  "block.minecraft.purple_stained_glass": "Fioletowe szkło",
  "block.minecraft.purple_stained_glass_pane": "Fioletowa szyba",
  "block.minecraft.purple_terracotta": "Fioletowa terakota",
  "block.minecraft.purple_wool": "Fioletowa wełna",
  "block.minecraft.purpur_block": "Blok purpuru",
  "block.minecraft.purpur_pillar": "Purpurowy filar",
  "block.minecraft.purpur_slab": "Purpurowa płyta",
  "block.minecraft.purpur_stairs": "Purpurowe schody",
  "block.minecraft.quartz_block": "Blok kwarcu",
  "block.minecraft.quartz_bricks": "Kwarcowe cegły",
  "block.minecraft.quartz_pillar": "Kwarcowy filar",
  "block.minecraft.quartz_slab": "Kwarcowa płyta",
  "block.minecraft.quartz_stairs": "Kwarcowe schody",
  "block.minecraft.rail": "Tory",
  "block.minecraft.raw_copper_block": "Blok rudy miedzi",
  "block.minecraft.raw_gold_block": "Blok surowego złota",
  "block.minecraft.raw_iron_block": "Blok rudy żelaza",
  "block.minecraft.red_banner": "Czerwony sztandar",
  "block.minecraft.red_bed": "Czerwone łóżko",
  "block.minecraft.red_candle": "Czerwona świeca",
  "block.minecraft.red_candle_cake": "Ciasto z czerwoną świeczką",
  "block.minecraft.red_carpet": "Czerwony dywan",
  "block.minecraft.red_concrete": "Czerwony beton",
  "block.minecraft.red_concrete_powder": "Czerwony cement",
  "block.minecraft.red_glazed_terracotta": "Czerwona glazurowana terakota",
  "block.minecraft.red_mushroom": "Muchomor",
  "block.minecraft.red_mushroom_block": "Blok muchomora",
  "block.minecraft.red_nether_brick_slab": "Czerwona netherowa ceglana płyta",
  "block.minecraft.red_nether_brick_stairs": "Czerwone netherowe ceglane schody",
  "block.minecraft.red_nether_brick_wall": "Czerwony netherowy ceglany murek",
  "block.minecraft.red_nether_bricks": "Czerwone netherowe cegły",
  "block.minecraft.red_sand": "Czerwony piasek",
  "block.minecraft.red_sandstone": "Czerwony piaskowiec",
  "block.minecraft.red_sandstone_slab": "Czerwona piaskowcowa płyta",
  "block.minecraft.red_sandstone_stairs": "Czerwone piaskowcowe schody",
  "block.minecraft.red_sandstone_wall": "Czerwony piaskowcowy murek",
  "block.minecraft.red_shulker_box": "Czerwona shulkerowa skrzynia",
  "block.minecraft.red_stained_glass": "Czerwone szkło",
  "block.minecraft.red_stained_glass_pane": "Czerwona szyba",
  "block.minecraft.red_terracotta": "Czerwona terakota",
  "block.minecraft.red_tulip": "Czerwony tulipan",
  "block.minecraft.red_wool": "Czerwona wełna",
  "block.minecraft.redstone_block": "Blok redstone",
  "block.minecraft.redstone_lamp": "Lampa redstone",
  "block.minecraft.redstone_ore": "Złoże redstone",
  "block.minecraft.redstone_torch": "Pochodnia redstone",
  "block.minecraft.redstone_wall_torch": "Ścienna pochodnia redstone",
  "block.minecraft.redstone_wire": "Przewód redstone",
  "block.minecraft.reinforced_deepslate": "Zbrojony łupek",
  "block.minecraft.repeater": "Przekaźnik redstone",
  "block.minecraft.repeating_command_block": "Powtarzający blok poleceń",
  "block.minecraft.resin_block": "Blok żywicy",
  "block.minecraft.resin_brick_slab": "Żywicowa ceglana płyta",
  "block.minecraft.resin_brick_stairs": "Żywicowe ceglane schody",
  "block.minecraft.resin_brick_wall": "Żywicowy ceglany murek",
  "block.minecraft.resin_bricks": "Żywicowe cegły",
  "block.minecraft.resin_clump": "Gruda żywicy",
  "block.minecraft.respawn_anchor": "Kotwica odrodzenia",
  "block.minecraft.rooted_dirt": "Zakorzeniona ziemia",
  "block.minecraft.rose_bush": "Krzew róży",
  "block.minecraft.sand": "Piasek",
  "block.minecraft.sandstone": "Piaskowiec",
  "block.minecraft.sandstone_slab": "Piaskowcowa płyta",
  "block.minecraft.sandstone_stairs": "Piaskowcowe schody",
  "block.minecraft.sandstone_wall": "Piaskowcowy murek",
  "block.minecraft.scaffolding": "Rusztowanie",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkowy katalizator",
  "block.minecraft.sculk_sensor": "Sculkowy czujnik",
  "block.minecraft.sculk_shrieker": "Sculkowe wrzeszczydło",
  "block.minecraft.sculk_vein": "Żyły sculku",
  "block.minecraft.sea_lantern": "Latarnia morska",
  "block.minecraft.sea_pickle": "Iskrzyłuda",
  "block.minecraft.seagrass": "Trawa morska",
  "block.minecraft.set_spawn": "Ustawiono punkt odradzania",
  "block.minecraft.short_dry_grass": "Niska sucha trawa",
  "block.minecraft.short_grass": "Niska trawa",
  "block.minecraft.shroomlight": "Światłogrzyb",
  "block.minecraft.shulker_box": "Shulkerowa skrzynia",
  "block.minecraft.skeleton_skull": "Czaszka szkieleta",
  "block.minecraft.skeleton_wall_skull": "Ścienna czaszka szkieleta",
  "block.minecraft.slime_block": "Blok szlamu",
  "block.minecraft.small_amethyst_bud": "Mały zarodek ametystu",
  "block.minecraft.small_dripleaf": "Mały spadkoliść",
  "block.minecraft.smithing_table": "Stół kowalski",
  "block.minecraft.smoker": "Wędzarka",
  "block.minecraft.smooth_basalt": "Gładki bazalt",
  "block.minecraft.smooth_quartz": "Gładki blok kwarcu",
  "block.minecraft.smooth_quartz_slab": "Gładka kwarcowa płyta",
  "block.minecraft.smooth_quartz_stairs": "Gładkie kwarcowe schody",
  "block.minecraft.smooth_red_sandstone": "Gładki czerwony piaskowiec",
  "block.minecraft.smooth_red_sandstone_slab": "Gładka czerwona piaskowcowa płyta",
  "block.minecraft.smooth_red_sandstone_stairs": "Gładkie czerwone piaskowcowe schody",
  "block.minecraft.smooth_sandstone": "Gładki piaskowiec",
  "block.minecraft.smooth_sandstone_slab": "Gładka piaskowcowa płyta",
  "block.minecraft.smooth_sandstone_stairs": "Gładkie piaskowcowe schody",
  "block.minecraft.smooth_stone": "Gładki kamień",
  "block.minecraft.smooth_stone_slab": "Gładka kamienna płyta",
  "block.minecraft.sniffer_egg": "Jajo niuchacza",
  "block.minecraft.snow": "Śnieg",
  "block.minecraft.snow_block": "Blok śniegu",
  "block.minecraft.soul_campfire": "Ognisko dusz",
  "block.minecraft.soul_fire": "Ogień dusz",
  "block.minecraft.soul_lantern": "Latarnia dusz",
  "block.minecraft.soul_sand": "Piasek dusz",
  "block.minecraft.soul_soil": "Gleba dusz",
  "block.minecraft.soul_torch": "Pochodnia dusz",
  "block.minecraft.soul_wall_torch": "Ścienna pochodnia dusz",
  "block.minecraft.spawn.not_valid": "Nie masz przypisanego łóżka lub naładowanej kotwicy odrodzenia, albo są one niedostępne",
  "block.minecraft.spawner": "Przyzywacz potworów",
  "block.minecraft.spawner.desc1": "Interakcja z jajem przyzywającym:",
  "block.minecraft.spawner.desc2": "Ustawia typ stworzenia",
  "block.minecraft.sponge": "Gąbka",
  "block.minecraft.spore_blossom": "Pylikwiat",
  "block.minecraft.spruce_button": "Świerkowy przycisk",
  "block.minecraft.spruce_door": "Świerkowe drzwi",
  "block.minecraft.spruce_fence": "Świerkowy płot",
  "block.minecraft.spruce_fence_gate": "Świerkowa furtka",
  "block.minecraft.spruce_hanging_sign": "Świerkowa podwieszana tabliczka",
  "block.minecraft.spruce_leaves": "Świerkowe liście",
  "block.minecraft.spruce_log": "Świerkowy pień",
  "block.minecraft.spruce_planks": "Świerkowe deski",
  "block.minecraft.spruce_pressure_plate": "Świerkowa płytka naciskowa",
  "block.minecraft.spruce_sapling": "Sadzonka świerku",
  "block.minecraft.spruce_shelf": "Świerkowa półka",
  "block.minecraft.spruce_sign": "Świerkowa tabliczka",
  "block.minecraft.spruce_slab": "Świerkowa płyta",
  "block.minecraft.spruce_stairs": "Świerkowe schody",
  "block.minecraft.spruce_trapdoor": "Świerkowa klapa",
  "block.minecraft.spruce_wall_hanging_sign": "Świerkowa ścienna podwieszana tabliczka",
  "block.minecraft.spruce_wall_sign": "Świerkowa ścienna tabliczka",
  "block.minecraft.spruce_wood": "Świerkowe drewno",
  "block.minecraft.sticky_piston": "Lepki tłok",
  "block.minecraft.stone": "Kamień",
  "block.minecraft.stone_brick_slab": "Kamienna ceglana płyta",
  "block.minecraft.stone_brick_stairs": "Kamienne ceglane schody",
  "block.minecraft.stone_brick_wall": "Kamienny ceglany murek",
  "block.minecraft.stone_bricks": "Kamienne cegły",
  "block.minecraft.stone_button": "Kamienny przycisk",
  "block.minecraft.stone_pressure_plate": "Kamienna płytka naciskowa",
  "block.minecraft.stone_slab": "Kamienna płyta",
  "block.minecraft.stone_stairs": "Kamienne schody",
  "block.minecraft.stonecutter": "Przecinarka",
  "block.minecraft.stripped_acacia_log": "Ociosany akacjowy pień",
  "block.minecraft.stripped_acacia_wood": "Ociosane akacjowe drewno",
  "block.minecraft.stripped_bamboo_block": "Blok ociosanego bambusu",
  "block.minecraft.stripped_birch_log": "Ociosany brzozowy pień",
  "block.minecraft.stripped_birch_wood": "Ociosane brzozowe drewno",
  "block.minecraft.stripped_cherry_log": "Ociosany wiśniowy pień",
  "block.minecraft.stripped_cherry_wood": "Ociosane wiśniowe drewno",
  "block.minecraft.stripped_crimson_hyphae": "Ociosane szkarłatne strzępki",
  "block.minecraft.stripped_crimson_stem": "Ociosany szkarłatny trzon",
  "block.minecraft.stripped_dark_oak_log": "Ociosany ciemnodębowy pień",
  "block.minecraft.stripped_dark_oak_wood": "Ociosane ciemnodębowe drewno",
  "block.minecraft.stripped_jungle_log": "Ociosany tropikalny pień",
  "block.minecraft.stripped_jungle_wood": "Ociosane tropikalne drewno",
  "block.minecraft.stripped_mangrove_log": "Ociosany namorzynowy pień",
  "block.minecraft.stripped_mangrove_wood": "Ociosane namorzynowe drewno",
  "block.minecraft.stripped_oak_log": "Ociosany dębowy pień",
  "block.minecraft.stripped_oak_wood": "Ociosane dębowe drewno",
  "block.minecraft.stripped_pale_oak_log": "Ociosany bladodębowy pień",
  "block.minecraft.stripped_pale_oak_wood": "Ociosane bladodębowe drewno",
  "block.minecraft.stripped_spruce_log": "Ociosany świerkowy pień",
  "block.minecraft.stripped_spruce_wood": "Ociosane świerkowe drewno",
  "block.minecraft.stripped_warped_hyphae": "Ociosane spaczone strzępki",
  "block.minecraft.stripped_warped_stem": "Ociosany spaczony trzon",
  "block.minecraft.structure_block": "Blok struktur",
  "block.minecraft.structure_void": "Pustka strukturalna",
  "block.minecraft.sugar_cane": "Trzcina cukrowa",
  "block.minecraft.sunflower": "Słonecznik",
  "block.minecraft.suspicious_gravel": "Podejrzany żwir",
  "block.minecraft.suspicious_sand": "Podejrzany piasek",
  "block.minecraft.sweet_berry_bush": "Krzew słodkich jagód",
  "block.minecraft.tall_dry_grass": "Wysoka sucha trawa",
  "block.minecraft.tall_grass": "Wysoka trawa",
  "block.minecraft.tall_seagrass": "Wysoka trawa morska",
  "block.minecraft.target": "Tarcza strzelecka",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Blok testowy",
  "block.minecraft.test_instance_block": "Blok instancji testowej",
  "block.minecraft.tinted_glass": "Przyciemnione szkło",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Wybuchy TNT są wyłączone",
  "block.minecraft.torch": "Pochodnia",
  "block.minecraft.torchflower": "Ognisty kwiat",
  "block.minecraft.torchflower_crop": "Ognisty kwiat",
  "block.minecraft.trapped_chest": "Skrzynia-pułapka",
  "block.minecraft.trial_spawner": "Przyzywacz prób",
  "block.minecraft.tripwire": "Linka",
  "block.minecraft.tripwire_hook": "Zaczep na linkę",
  "block.minecraft.tube_coral": "Koralowiec rurkowaty",
  "block.minecraft.tube_coral_block": "Blok koralowca rurkowatego",
  "block.minecraft.tube_coral_fan": "Wachlarz koralowca rurkowatego",
  "block.minecraft.tube_coral_wall_fan": "Wachlarz naścienny koralowca rurkowatego",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Tufowa ceglana płyta",
  "block.minecraft.tuff_brick_stairs": "Tufowe ceglane schody",
  "block.minecraft.tuff_brick_wall": "Tufowy ceglany murek",
  "block.minecraft.tuff_bricks": "Tufowe cegły",
  "block.minecraft.tuff_slab": "Tufowa płyta",
  "block.minecraft.tuff_stairs": "Tufowe schody",
  "block.minecraft.tuff_wall": "Tufowy murek",
  "block.minecraft.turtle_egg": "Żółwie jajko",
  "block.minecraft.twisting_vines": "Spaczone pnącza",
  "block.minecraft.twisting_vines_plant": "Rosnące spaczone pnącza",
  "block.minecraft.vault": "Skarbiec",
  "block.minecraft.verdant_froglight": "Zielenista żabia lampa",
  "block.minecraft.vine": "Pnącza",
  "block.minecraft.void_air": "Próżniowe powietrze",
  "block.minecraft.wall_torch": "Ścienna pochodnia",
  "block.minecraft.warped_button": "Spaczony przycisk",
  "block.minecraft.warped_door": "Spaczone drzwi",
  "block.minecraft.warped_fence": "Spaczony płot",
  "block.minecraft.warped_fence_gate": "Spaczona furtka",
  "block.minecraft.warped_fungus": "Spaczony grzyb",
  "block.minecraft.warped_hanging_sign": "Spaczona podwieszana tabliczka",
  "block.minecraft.warped_hyphae": "Spaczone strzępki",
  "block.minecraft.warped_nylium": "Spaczone nylium",
  "block.minecraft.warped_planks": "Spaczone deski",
  "block.minecraft.warped_pressure_plate": "Spaczona płytka naciskowa",
  "block.minecraft.warped_roots": "Spaczone korzenie",
  "block.minecraft.warped_shelf": "Spaczona półka",
  "block.minecraft.warped_sign": "Spaczona tabliczka",
  "block.minecraft.warped_slab": "Spaczona płyta",
  "block.minecraft.warped_stairs": "Spaczone schody",
  "block.minecraft.warped_stem": "Spaczony trzon",
  "block.minecraft.warped_trapdoor": "Spaczona klapa",
  "block.minecraft.warped_wall_hanging_sign": "Spaczona ścienna podwieszana tabliczka",
  "block.minecraft.warped_wall_sign": "Spaczona ścienna tabliczka",
  "block.minecraft.warped_wart_block": "Blok spaczonych brodawek",
  "block.minecraft.water": "Woda",
  "block.minecraft.water_cauldron": "Kocioł wody",
  "block.minecraft.waxed_chiseled_copper": "Woskowana rzeźbiona miedź",
  "block.minecraft.waxed_copper_bars": "Woskowane miedziane kraty",
  "block.minecraft.waxed_copper_block": "Woskowany blok miedzi",
  "block.minecraft.waxed_copper_bulb": "Woskowana miedziana lampa",
  "block.minecraft.waxed_copper_chain": "Woskowany miedziany łańcuch",
  "block.minecraft.waxed_copper_chest": "Woskowana miedziana skrzynia",
  "block.minecraft.waxed_copper_door": "Woskowane miedziane drzwi",
  "block.minecraft.waxed_copper_golem_statue": "Woskowany posąg miedzianego golema",
  "block.minecraft.waxed_copper_grate": "Woskowana miedziana krata",
  "block.minecraft.waxed_copper_lantern": "Woskowana miedziana latarnia",
  "block.minecraft.waxed_copper_trapdoor": "Woskowana miedziana klapa",
  "block.minecraft.waxed_cut_copper": "Woskowana żłobiona miedź",
  "block.minecraft.waxed_cut_copper_slab": "Woskowana żłobiona miedziana płyta",
  "block.minecraft.waxed_cut_copper_stairs": "Woskowane żłobione miedziane schody",
  "block.minecraft.waxed_exposed_chiseled_copper": "Woskowana zwietrzała rzeźbiona miedź",
  "block.minecraft.waxed_exposed_copper": "Woskowana zwietrzała miedź",
  "block.minecraft.waxed_exposed_copper_bars": "Woskowane zwietrzałe miedziane kraty",
  "block.minecraft.waxed_exposed_copper_bulb": "Woskowana zwietrzała miedziana lampa",
  "block.minecraft.waxed_exposed_copper_chain": "Woskowany zwietrzały miedziany łańcuch",
  "block.minecraft.waxed_exposed_copper_chest": "Woskowana zwietrzała miedziana skrzynia",
  "block.minecraft.waxed_exposed_copper_door": "Woskowane zwietrzałe miedziane drzwi",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Woskowany zwietrzały posąg miedzianego golema",
  "block.minecraft.waxed_exposed_copper_grate": "Woskowana zwietrzała miedziana krata",
  "block.minecraft.waxed_exposed_copper_lantern": "Woskowana zwietrzała miedziana latarnia",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Woskowana zwietrzała miedziana klapa",
  "block.minecraft.waxed_exposed_cut_copper": "Woskowana zwietrzała żłobiona miedź",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Woskowana zwietrzała żłobiona miedziana płyta",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Woskowane zwietrzałe żłobione miedziane schody",
  "block.minecraft.waxed_exposed_lightning_rod": "Woskowany zwietrzały piorunochron",
  "block.minecraft.waxed_lightning_rod": "Woskowany piorunochron",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Woskowana utleniona rzeźbiona miedź",
  "block.minecraft.waxed_oxidized_copper": "Woskowana utleniona miedź",
  "block.minecraft.waxed_oxidized_copper_bars": "Woskowane utlenione miedziane kraty",
  "block.minecraft.waxed_oxidized_copper_bulb": "Woskowana utleniona miedziana lampa",
  "block.minecraft.waxed_oxidized_copper_chain": "Woskowany utleniony miedziany łańcuch",
  "block.minecraft.waxed_oxidized_copper_chest": "Woskowana utleniona miedziana skrzynia",
  "block.minecraft.waxed_oxidized_copper_door": "Woskowane utlenione miedziane drzwi",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Woskowany utleniony posąg miedzianego golema",
  "block.minecraft.waxed_oxidized_copper_grate": "Woskowana utleniona miedziana krata",
  "block.minecraft.waxed_oxidized_copper_lantern": "Woskowana utleniona miedziana latarnia",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Woskowana utleniona miedziana klapa",
  "block.minecraft.waxed_oxidized_cut_copper": "Woskowana utleniona żłobiona miedź",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Woskowana utleniona żłobiona miedziana płyta",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Woskowane utlenione żłobione miedziane schody",
  "block.minecraft.waxed_oxidized_lightning_rod": "Woskowany utleniony piorunochron",
  "block.minecraft.waxed_weathered_chiseled_copper": "Woskowana zaśniedziała rzeźbiona miedź",
  "block.minecraft.waxed_weathered_copper": "Woskowana zaśniedziała miedź",
  "block.minecraft.waxed_weathered_copper_bars": "Woskowane zaśniedziałe miedziane kraty",
  "block.minecraft.waxed_weathered_copper_bulb": "Woskowana zaśniedziała miedziana lampa",
  "block.minecraft.waxed_weathered_copper_chain": "Woskowany zaśniedziały miedziany łańcuch",
  "block.minecraft.waxed_weathered_copper_chest": "Woskowana zaśniedziała miedziana skrzynia",
  "block.minecraft.waxed_weathered_copper_door": "Woskowane zaśniedziałe miedziane drzwi",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Woskowany zaśniedziały posąg miedzianego golema",
  "block.minecraft.waxed_weathered_copper_grate": "Woskowana zaśniedziała miedziana krata",
  "block.minecraft.waxed_weathered_copper_lantern": "Woskowana zaśniedziała miedziana latarnia",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Woskowana zaśniedziała miedziana klapa",
  "block.minecraft.waxed_weathered_cut_copper": "Woskowana zaśniedziała żłobiona miedź",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Woskowana zaśniedziała żłobiona miedziana płyta",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Woskowane zaśniedziałe żłobione miedziane schody",
  "block.minecraft.waxed_weathered_lightning_rod": "Woskowany zaśniedziały piorunochron",
  "block.minecraft.weathered_chiseled_copper": "Zaśniedziała rzeźbiona miedź",
  "block.minecraft.weathered_copper": "Zaśniedziała miedź",
  "block.minecraft.weathered_copper_bars": "Zaśniedziałe miedziane kraty",
  "block.minecraft.weathered_copper_bulb": "Zaśniedziała miedziana lampa",
  "block.minecraft.weathered_copper_chain": "Zaśniedziały miedziany łańcuch",
  "block.minecraft.weathered_copper_chest": "Zaśniedziała miedziana skrzynia",
  "block.minecraft.weathered_copper_door": "Zaśniedziałe miedziane drzwi",
  "block.minecraft.weathered_copper_golem_statue": "Zaśniedziały posąg miedzianego golema",
  "block.minecraft.weathered_copper_grate": "Zaśniedziała miedziana krata",
  "block.minecraft.weathered_copper_lantern": "Zaśniedziała miedziana latarnia",
  "block.minecraft.weathered_copper_trapdoor": "Zaśniedziała miedziana klapa",
  "block.minecraft.weathered_cut_copper": "Zaśniedziała żłobiona miedź",
  "block.minecraft.weathered_cut_copper_slab": "Zaśniedziała żłobiona miedziana płyta",
  "block.minecraft.weathered_cut_copper_stairs": "Zaśniedziałe żłobione miedziane schody",
  "block.minecraft.weathered_lightning_rod": "Zaśniedziały piorunochron",
  "block.minecraft.weeping_vines": "Płaczące pnącza",
  "block.minecraft.weeping_vines_plant": "Rosnące płaczące pnącza",
  "block.minecraft.wet_sponge": "Mokra gąbka",
  "block.minecraft.wheat": "Pszenica",
  "block.minecraft.white_banner": "Biały sztandar",
  "block.minecraft.white_bed": "Białe łóżko",
  "block.minecraft.white_candle": "Biała świeca",
  "block.minecraft.white_candle_cake": "Ciasto z białą świeczką",
  "block.minecraft.white_carpet": "Biały dywan",
  "block.minecraft.white_concrete": "Biały beton",
  "block.minecraft.white_concrete_powder": "Biały cement",
  "block.minecraft.white_glazed_terracotta": "Biała glazurowana terakota",
  "block.minecraft.white_shulker_box": "Biała shulkerowa skrzynia",
  "block.minecraft.white_stained_glass": "Białe szkło",
  "block.minecraft.white_stained_glass_pane": "Biała szyba",
  "block.minecraft.white_terracotta": "Biała terakota",
  "block.minecraft.white_tulip": "Biały tulipan",
  "block.minecraft.white_wool": "Biała wełna",
  "block.minecraft.wildflowers": "Polne kwiaty",
  "block.minecraft.wither_rose": "Witherowa róża",
  "block.minecraft.wither_skeleton_skull": "Czaszka witherowego szkieleta",
  "block.minecraft.wither_skeleton_wall_skull": "Ścienna czaszka witherowego szkieleta",
  "block.minecraft.yellow_banner": "Żółty sztandar",
  "block.minecraft.yellow_bed": "Żółte łóżko",
  "block.minecraft.yellow_candle": "Żółta świeca",
  "block.minecraft.yellow_candle_cake": "Ciasto z żółtą świeczką",
  "block.minecraft.yellow_carpet": "Żółty dywan",
  "block.minecraft.yellow_concrete": "Żółty beton",
  "block.minecraft.yellow_concrete_powder": "Żółty cement",
  "block.minecraft.yellow_glazed_terracotta": "Żółta glazurowana terakota",
  "block.minecraft.yellow_shulker_box": "Żółta shulkerowa skrzynia",
  "block.minecraft.yellow_stained_glass": "Żółte szkło",
  "block.minecraft.yellow_stained_glass_pane": "Żółta szyba",
  "block.minecraft.yellow_terracotta": "Żółta terakota",
  "block.minecraft.yellow_wool": "Żółta wełna",
  "block.minecraft.zombie_head": "Głowa zombie",
  "block.minecraft.zombie_wall_head": "Ścienna głowa zombie",
  "item.minecraft.acacia_boat": "Akacjowa łódka",
  "item.minecraft.acacia_chest_boat": "Akacjowa łódka ze skrzynią",
  "item.minecraft.allay_spawn_egg": "Jajo przyzywające otuszka",
  "item.minecraft.amethyst_shard": "Odłamek ametystu",
  "item.minecraft.angler_pottery_shard": "Odłamek ceramiki „Rybak”",
  "item.minecraft.angler_pottery_sherd": "Odłamek ceramiki „Rybak”",
  "item.minecraft.apple": "Jabłko",
  "item.minecraft.archer_pottery_shard": "Odłamek ceramiki „Łucznik”",
  "item.minecraft.archer_pottery_sherd": "Odłamek ceramiki „Łucznik”",
  "item.minecraft.armadillo_scute": "Tarczka pancernika",
  "item.minecraft.armadillo_spawn_egg": "Jajo przyzywające pancernika",
  "item.minecraft.armor_stand": "Stojak na zbroję",
  "item.minecraft.arms_up_pottery_shard": "Odłamek ceramiki „Ręce w górze”",
  "item.minecraft.arms_up_pottery_sherd": "Odłamek ceramiki „Ręce w górze”",
  "item.minecraft.arrow": "Strzała",
  "item.minecraft.axolotl_bucket": "Wiadro z aksolotlem",
  "item.minecraft.axolotl_spawn_egg": "Jajo przyzywające aksolotla",
  "item.minecraft.baked_potato": "Pieczony ziemniak",
  "item.minecraft.bamboo_chest_raft": "Bambusowa tratwa ze skrzynią",
  "item.minecraft.bamboo_raft": "Bambusowa tratwa",
  "item.minecraft.bat_spawn_egg": "Jajo przyzywające nietoperza",
  "item.minecraft.bee_spawn_egg": "Jajo przyzywające pszczołę",
  "item.minecraft.beef": "Surowa wołowina",
  "item.minecraft.beetroot": "Burak",
  "item.minecraft.beetroot_seeds": "Nasiona buraka",
  "item.minecraft.beetroot_soup": "Barszcz czerwony",
  "item.minecraft.birch_boat": "Brzozowa łódka",
  "item.minecraft.birch_chest_boat": "Brzozowa łódka ze skrzynią",
  "item.minecraft.black_bundle": "Czarna sakwa",
  "item.minecraft.black_dye": "Czarny barwnik",
  "item.minecraft.black_harness": "Czarna uprząż",
  "item.minecraft.blade_pottery_shard": "Odłamek ceramiki „Ostrze”",
  "item.minecraft.blade_pottery_sherd": "Odłamek ceramiki „Ostrze”",
  "item.minecraft.blaze_powder": "Płomienny proszek",
  "item.minecraft.blaze_rod": "Płomienna różdżka",
  "item.minecraft.blaze_spawn_egg": "Jajo przyzywające płomyka",
  "item.minecraft.blue_bundle": "Niebieska sakwa",
  "item.minecraft.blue_dye": "Niebieski barwnik",
  "item.minecraft.blue_egg": "Niebieskie jajko",
  "item.minecraft.blue_harness": "Niebieska uprząż",
  "item.minecraft.bogged_spawn_egg": "Jajo przyzywające bagniaka",
  "item.minecraft.bolt_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Zdobienie zbroi „Nit”",
  "item.minecraft.bone": "Kość",
  "item.minecraft.bone_meal": "Mączka kostna",
  "item.minecraft.book": "Książka",
  "item.minecraft.bordure_indented_banner_pattern": "Wzór sztandaru — ząbkowane obramowanie",
  "item.minecraft.bow": "Łuk",
  "item.minecraft.bowl": "Miska",
  "item.minecraft.bread": "Chleb",
  "item.minecraft.breeze_rod": "Wichrowa różdżka",
  "item.minecraft.breeze_spawn_egg": "Jajo przyzywające wichrzyka",
  "item.minecraft.brewer_pottery_shard": "Odłamek ceramiki „Alchemik”",
  "item.minecraft.brewer_pottery_sherd": "Odłamek ceramiki „Alchemik”",
  "item.minecraft.brewing_stand": "Statyw alchemiczny",
  "item.minecraft.brick": "Cegła",
  "item.minecraft.brown_bundle": "Brązowa sakwa",
  "item.minecraft.brown_dye": "Brązowy barwnik",
  "item.minecraft.brown_egg": "Brązowe jajko",
  "item.minecraft.brown_harness": "Brązowa uprząż",
  "item.minecraft.brush": "Pędzel",
  "item.minecraft.bucket": "Wiadro",
  "item.minecraft.bundle": "Sakwa",
  "item.minecraft.bundle.empty": "Pusta",
  "item.minecraft.bundle.empty.description": "Może przechowywać stos różnorakich przedmiotów",
  "item.minecraft.bundle.full": "Pełna",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Odłamek ceramiki „Płomień”",
  "item.minecraft.burn_pottery_sherd": "Odłamek ceramiki „Płomień”",
  "item.minecraft.camel_husk_spawn_egg": "Jajo przyzywające wielbłąda-posucha",
  "item.minecraft.camel_spawn_egg": "Jajo przyzywające wielbłąda",
  "item.minecraft.carrot": "Marchewka",
  "item.minecraft.carrot_on_a_stick": "Marchewka na patyku",
  "item.minecraft.cat_spawn_egg": "Jajo przyzywające kota",
  "item.minecraft.cauldron": "Kocioł",
  "item.minecraft.cave_spider_spawn_egg": "Jajo przyzywające pająka jaskiniowego",
  "item.minecraft.chainmail_boots": "Kolcze buty",
  "item.minecraft.chainmail_chestplate": "Kolczy napierśnik",
  "item.minecraft.chainmail_helmet": "Kolczy hełm",
  "item.minecraft.chainmail_leggings": "Kolcze nogawice",
  "item.minecraft.charcoal": "Węgiel drzewny",
  "item.minecraft.cherry_boat": "Wiśniowa łódka",
  "item.minecraft.cherry_chest_boat": "Wiśniowa łódka ze skrzynią",
  "item.minecraft.chest_minecart": "Wagonik ze skrzynią",
  "item.minecraft.chicken": "Surowy kurczak",
  "item.minecraft.chicken_spawn_egg": "Jajo przyzywające kurę",
  "item.minecraft.chorus_fruit": "Owoc refrenusu",
  "item.minecraft.clay_ball": "Kulka gliny",
  "item.minecraft.clock": "Zegar",
  "item.minecraft.coal": "Węgiel",
  "item.minecraft.coast_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Zdobienie zbroi „Wybrzeże”",
  "item.minecraft.cocoa_beans": "Ziarna kakaowe",
  "item.minecraft.cod": "Surowy dorsz",
  "item.minecraft.cod_bucket": "Wiadro z dorszem",
  "item.minecraft.cod_spawn_egg": "Jajo przyzywające dorsza",
  "item.minecraft.command_block_minecart": "Wagonik z blokiem poleceń",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Pieczona wołowina",
  "item.minecraft.cooked_chicken": "Pieczony kurczak",
  "item.minecraft.cooked_cod": "Pieczony dorsz",
  "item.minecraft.cooked_mutton": "Pieczona baranina",
  "item.minecraft.cooked_porkchop": "Pieczona wieprzowina",
  "item.minecraft.cooked_rabbit": "Pieczony królik",
  "item.minecraft.cooked_salmon": "Pieczony łosoś",
  "item.minecraft.cookie": "Ciastko",
  "item.minecraft.copper_axe": "Miedziana siekiera",
  "item.minecraft.copper_boots": "Miedziane buty",
  "item.minecraft.copper_chestplate": "Miedziany napierśnik",
  "item.minecraft.copper_golem_spawn_egg": "Jajo przyzywające miedzianego golema",
  "item.minecraft.copper_helmet": "Miedziany hełm",
  "item.minecraft.copper_hoe": "Miedziana motyka",
  "item.minecraft.copper_horse_armor": "Miedziana zbroja końska",
  "item.minecraft.copper_ingot": "Sztabka miedzi",
  "item.minecraft.copper_leggings": "Miedziane nogawice",
  "item.minecraft.copper_nautilus_armor": "Miedziana zbroja łodzika",
  "item.minecraft.copper_nugget": "Bryłka miedzi",
  "item.minecraft.copper_pickaxe": "Miedziany kilof",
  "item.minecraft.copper_shovel": "Miedziana łopata",
  "item.minecraft.copper_spear": "Miedziana włócznia",
  "item.minecraft.copper_sword": "Miedziany miecz",
  "item.minecraft.cow_spawn_egg": "Jajo przyzywające krowę",
  "item.minecraft.creaking_spawn_egg": "Jajo przyzywające trzeszcza",
  "item.minecraft.creeper_banner_pattern": "Wzór sztandaru",
  "item.minecraft.creeper_banner_pattern.desc": "Wizerunek creepera",
  "item.minecraft.creeper_banner_pattern.new": "Wzór sztandaru — wizerunek creepera",
  "item.minecraft.creeper_spawn_egg": "Jajo przyzywające creepera",
  "item.minecraft.crossbow": "Kusza",
  "item.minecraft.crossbow.projectile": "Pocisk:",
  "item.minecraft.crossbow.projectile.multiple": "Pocisk: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Pocisk: %s",
  "item.minecraft.cyan_bundle": "Błękitna sakwa",
  "item.minecraft.cyan_dye": "Błękitny barwnik",
  "item.minecraft.cyan_harness": "Błękitna uprząż",
  "item.minecraft.danger_pottery_shard": "Odłamek ceramiki „Zagrożenie”",
  "item.minecraft.danger_pottery_sherd": "Odłamek ceramiki „Zagrożenie”",
  "item.minecraft.dark_oak_boat": "Ciemnodębowa łódka",
  "item.minecraft.dark_oak_chest_boat": "Ciemnodębowa łódka ze skrzynią",
  "item.minecraft.debug_stick": "Patyk debugujący",
  "item.minecraft.debug_stick.empty": "%s nie ma właściwości",
  "item.minecraft.debug_stick.select": "wybrano „%s” (%s)",
  "item.minecraft.debug_stick.update": "ustawiono „%s” na %s",
  "item.minecraft.diamond": "Diament",
  "item.minecraft.diamond_axe": "Diamentowa siekiera",
  "item.minecraft.diamond_boots": "Diamentowe buty",
  "item.minecraft.diamond_chestplate": "Diamentowy napierśnik",
  "item.minecraft.diamond_helmet": "Diamentowy hełm",
  "item.minecraft.diamond_hoe": "Diamentowa motyka",
  "item.minecraft.diamond_horse_armor": "Diamentowa zbroja końska",
  "item.minecraft.diamond_leggings": "Diamentowe nogawice",
  "item.minecraft.diamond_nautilus_armor": "Diamentowa zbroja łodzika",
  "item.minecraft.diamond_pickaxe": "Diamentowy kilof",
  "item.minecraft.diamond_shovel": "Diamentowa łopata",
  "item.minecraft.diamond_spear": "Diamentowa włócznia",
  "item.minecraft.diamond_sword": "Diamentowy miecz",
  "item.minecraft.disc_fragment_5": "Fragment płyty",
  "item.minecraft.disc_fragment_5.desc": "Płyta muzyczna — 5",
  "item.minecraft.dolphin_spawn_egg": "Jajo przyzywające delfina",
  "item.minecraft.donkey_spawn_egg": "Jajo przyzywające osła",
  "item.minecraft.dragon_breath": "Oddech smoka",
  "item.minecraft.dried_kelp": "Suszony wodorost",
  "item.minecraft.drowned_spawn_egg": "Jajo przyzywające utopca",
  "item.minecraft.dune_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Zdobienie zbroi „Wydma”",
  "item.minecraft.echo_shard": "Odłamek echa",
  "item.minecraft.egg": "Jajko",
  "item.minecraft.elder_guardian_spawn_egg": "Jajo przyzywające prastrażnika",
  "item.minecraft.elytra": "Elytry",
  "item.minecraft.emerald": "Szmaragd",
  "item.minecraft.enchanted_book": "Zaklęta książka",
  "item.minecraft.enchanted_golden_apple": "Zaklęte złote jabłko",
  "item.minecraft.end_crystal": "Kryształ Endu",
  "item.minecraft.ender_dragon_spawn_egg": "Jajo przyzywające smoka Endu",
  "item.minecraft.ender_eye": "Oko Endera",
  "item.minecraft.ender_pearl": "Enderperła",
  "item.minecraft.enderman_spawn_egg": "Jajo przyzywające endermana",
  "item.minecraft.endermite_spawn_egg": "Jajo przyzywające endermita",
  "item.minecraft.evoker_spawn_egg": "Jajo przyzywające przywoływacza",
  "item.minecraft.experience_bottle": "Zaklęta butelka",
  "item.minecraft.explorer_pottery_shard": "Odłamek ceramiki „Odkrywca”",
  "item.minecraft.explorer_pottery_sherd": "Odłamek ceramiki „Odkrywca”",
  "item.minecraft.eye_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Zdobienie zbroi „Oko”",
  "item.minecraft.feather": "Pióro",
  "item.minecraft.fermented_spider_eye": "Sfermentowane oko pająka",
  "item.minecraft.field_masoned_banner_pattern": "Wzór sztandaru — mur",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Ognista kula",
  "item.minecraft.firework_rocket": "Fajerwerk",
  "item.minecraft.firework_rocket.flight": "Czas lotu:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Gwiazdka pirotechniczna",
  "item.minecraft.firework_star.black": "Czarny",
  "item.minecraft.firework_star.blue": "Niebieski",
  "item.minecraft.firework_star.brown": "Brązowy",
  "item.minecraft.firework_star.custom_color": "Własny",
  "item.minecraft.firework_star.cyan": "Błękitny",
  "item.minecraft.firework_star.fade_to": "Przechodzący w",
  "item.minecraft.firework_star.flicker": "Iskrzenie",
  "item.minecraft.firework_star.gray": "Szary",
  "item.minecraft.firework_star.green": "Zielony",
  "item.minecraft.firework_star.light_blue": "Jasnoniebieski",
  "item.minecraft.firework_star.light_gray": "Jasnoszary",
  "item.minecraft.firework_star.lime": "Jasnozielony",
  "item.minecraft.firework_star.magenta": "Purpurowy",
  "item.minecraft.firework_star.orange": "Pomarańczowy",
  "item.minecraft.firework_star.pink": "Różowy",
  "item.minecraft.firework_star.purple": "Fioletowy",
  "item.minecraft.firework_star.red": "Czerwony",
  "item.minecraft.firework_star.shape": "Nieznany kształt",
  "item.minecraft.firework_star.shape.burst": "Rozproszenie",
  "item.minecraft.firework_star.shape.creeper": "Kształt creepera",
  "item.minecraft.firework_star.shape.large_ball": "Duża kula",
  "item.minecraft.firework_star.shape.small_ball": "Mała kula",
  "item.minecraft.firework_star.shape.star": "Kształt gwiazdy",
  "item.minecraft.firework_star.trail": "Smuga",
  "item.minecraft.firework_star.white": "Biały",
  "item.minecraft.firework_star.yellow": "Żółty",
  "item.minecraft.fishing_rod": "Wędka",
  "item.minecraft.flint": "Krzemień",
  "item.minecraft.flint_and_steel": "Krzesiwo",
  "item.minecraft.flow_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Zdobienie zbroi „Nurt”",
  "item.minecraft.flow_banner_pattern": "Wzór sztandaru",
  "item.minecraft.flow_banner_pattern.desc": "Nurt",
  "item.minecraft.flow_banner_pattern.new": "Wzór sztandaru — nurt",
  "item.minecraft.flow_pottery_sherd": "Odłamek ceramiki „Nurt”",
  "item.minecraft.flower_banner_pattern": "Wzór sztandaru",
  "item.minecraft.flower_banner_pattern.desc": "Wzór kwiatu",
  "item.minecraft.flower_banner_pattern.new": "Wzór sztandaru — kwiat",
  "item.minecraft.flower_pot": "Doniczka",
  "item.minecraft.fox_spawn_egg": "Jajo przyzywające lisa",
  "item.minecraft.friend_pottery_shard": "Odłamek ceramiki „Druh”",
  "item.minecraft.friend_pottery_sherd": "Odłamek ceramiki „Druh”",
  "item.minecraft.frog_spawn_egg": "Jajo przyzywające żabę",
  "item.minecraft.furnace_minecart": "Napędzany wagonik",
  "item.minecraft.ghast_spawn_egg": "Jajo przyzywające ghasta",
  "item.minecraft.ghast_tear": "Łza ghasta",
  "item.minecraft.glass_bottle": "Szklana butelka",
  "item.minecraft.glistering_melon_slice": "Kawałek lśniącego arbuza",
  "item.minecraft.globe_banner_pattern": "Wzór sztandaru",
  "item.minecraft.globe_banner_pattern.desc": "Sześcian ziemski",
  "item.minecraft.globe_banner_pattern.new": "Wzór sztandaru — glob",
  "item.minecraft.glow_berries": "Świecące jagody",
  "item.minecraft.glow_ink_sac": "Torbiel ze świecącym atramentem",
  "item.minecraft.glow_item_frame": "Świecąca ramka na przedmiot",
  "item.minecraft.glow_squid_spawn_egg": "Jajo przyzywające świecącą kałamarnicę",
  "item.minecraft.glowstone_dust": "Jasnopył",
  "item.minecraft.goat_horn": "Kozi róg",
  "item.minecraft.goat_spawn_egg": "Jajo przyzywające kozę",
  "item.minecraft.gold_ingot": "Sztabka złota",
  "item.minecraft.gold_nugget": "Bryłka złota",
  "item.minecraft.golden_apple": "Złote jabłko",
  "item.minecraft.golden_axe": "Złota siekiera",
  "item.minecraft.golden_boots": "Złote buty",
  "item.minecraft.golden_carrot": "Złota marchewka",
  "item.minecraft.golden_chestplate": "Złoty napierśnik",
  "item.minecraft.golden_helmet": "Złoty hełm",
  "item.minecraft.golden_hoe": "Złota motyka",
  "item.minecraft.golden_horse_armor": "Złota zbroja końska",
  "item.minecraft.golden_leggings": "Złote nogawice",
  "item.minecraft.golden_nautilus_armor": "Złota zbroja łodzika",
  "item.minecraft.golden_pickaxe": "Złoty kilof",
  "item.minecraft.golden_shovel": "Złota łopata",
  "item.minecraft.golden_spear": "Złota włócznia",
  "item.minecraft.golden_sword": "Złoty miecz",
  "item.minecraft.gray_bundle": "Szara sakwa",
  "item.minecraft.gray_dye": "Szary barwnik",
  "item.minecraft.gray_harness": "Szara uprząż",
  "item.minecraft.green_bundle": "Zielona sakwa",
  "item.minecraft.green_dye": "Zielony barwnik",
  "item.minecraft.green_harness": "Zielona uprząż",
  "item.minecraft.guardian_spawn_egg": "Jajo przyzywające strażnika",
  "item.minecraft.gunpowder": "Proch",
  "item.minecraft.guster_banner_pattern": "Wzór sztandaru",
  "item.minecraft.guster_banner_pattern.desc": "Podmuch",
  "item.minecraft.guster_banner_pattern.new": "Wzór sztandaru — podmuch",
  "item.minecraft.guster_pottery_sherd": "Odłamek ceramiki „Podmuch”",
  "item.minecraft.happy_ghast_spawn_egg": "Jajo przyzywające wesołego ghasta",
  "item.minecraft.harness": "Uprząż",
  "item.minecraft.heart_of_the_sea": "Serce oceanu",
  "item.minecraft.heart_pottery_shard": "Odłamek ceramiki „Serce”",
  "item.minecraft.heart_pottery_sherd": "Odłamek ceramiki „Serce”",
  "item.minecraft.heartbreak_pottery_shard": "Odłamek ceramiki „Złamane serce”",
  "item.minecraft.heartbreak_pottery_sherd": "Odłamek ceramiki „Złamane serce”",
  "item.minecraft.hoglin_spawn_egg": "Jajo przyzywające hoglina",
  "item.minecraft.honey_bottle": "Butelka miodu",
  "item.minecraft.honeycomb": "Plaster miodu",
  "item.minecraft.hopper_minecart": "Wagonik z lejem",
  "item.minecraft.horse_spawn_egg": "Jajo przyzywające konia",
  "item.minecraft.host_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.host_armor_trim_smithing_template.new": "Zdobienie zbroi „Gospodarz”",
  "item.minecraft.howl_pottery_shard": "Odłamek ceramiki „Skowyt”",
  "item.minecraft.howl_pottery_sherd": "Odłamek ceramiki „Skowyt”",
  "item.minecraft.husk_spawn_egg": "Jajo przyzywające posucha",
  "item.minecraft.ink_sac": "Torbiel z atramentem",
  "item.minecraft.iron_axe": "Żelazna siekiera",
  "item.minecraft.iron_boots": "Żelazne buty",
  "item.minecraft.iron_chestplate": "Żelazny napierśnik",
  "item.minecraft.iron_golem_spawn_egg": "Jajo przyzywające żelaznego golema",
  "item.minecraft.iron_helmet": "Żelazny hełm",
  "item.minecraft.iron_hoe": "Żelazna motyka",
  "item.minecraft.iron_horse_armor": "Żelazna zbroja końska",
  "item.minecraft.iron_ingot": "Sztabka żelaza",
  "item.minecraft.iron_leggings": "Żelazne nogawice",
  "item.minecraft.iron_nautilus_armor": "Żelazna zbroja łodzika",
  "item.minecraft.iron_nugget": "Bryłka żelaza",
  "item.minecraft.iron_pickaxe": "Żelazny kilof",
  "item.minecraft.iron_shovel": "Żelazna łopata",
  "item.minecraft.iron_spear": "Żelazna włócznia",
  "item.minecraft.iron_sword": "Żelazny miecz",
  "item.minecraft.item_frame": "Ramka na przedmiot",
  "item.minecraft.jungle_boat": "Tropikalna łódka",
  "item.minecraft.jungle_chest_boat": "Tropikalna łódka ze skrzynią",
  "item.minecraft.knowledge_book": "Księga wiedzy",
  "item.minecraft.lapis_lazuli": "Lazuryt",
  "item.minecraft.lava_bucket": "Wiadro lawy",
  "item.minecraft.lead": "Lina",
  "item.minecraft.leather": "Skóra",
  "item.minecraft.leather_boots": "Skórzane buty",
  "item.minecraft.leather_chestplate": "Skórzana tunika",
  "item.minecraft.leather_helmet": "Skórzana czapka",
  "item.minecraft.leather_horse_armor": "Skórzana zbroja końska",
  "item.minecraft.leather_leggings": "Skórzane spodnie",
  "item.minecraft.light_blue_bundle": "Jasnoniebieska sakwa",
  "item.minecraft.light_blue_dye": "Jasnoniebieski barwnik",
  "item.minecraft.light_blue_harness": "Jasnoniebieska uprząż",
  "item.minecraft.light_gray_bundle": "Jasnoszara sakwa",
  "item.minecraft.light_gray_dye": "Jasnoszary barwnik",
  "item.minecraft.light_gray_harness": "Jasnoszara uprząż",
  "item.minecraft.lime_bundle": "Jasnozielona sakwa",
  "item.minecraft.lime_dye": "Jasnozielony barwnik",
  "item.minecraft.lime_harness": "Jasnozielona uprząż",
  "item.minecraft.lingering_potion": "Trwała mikstura",
  "item.minecraft.lingering_potion.effect.awkward": "Trwała klarowna mikstura",
  "item.minecraft.lingering_potion.effect.empty": "Trwała niewykonalna mikstura",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Trwała mikstura ognioodporności",
  "item.minecraft.lingering_potion.effect.harming": "Trwała mikstura krzywdy",
  "item.minecraft.lingering_potion.effect.healing": "Trwała mikstura leczenia",
  "item.minecraft.lingering_potion.effect.infested": "Trwała mikstura zarobaczenia",
  "item.minecraft.lingering_potion.effect.invisibility": "Trwała mikstura niewidzialności",
  "item.minecraft.lingering_potion.effect.leaping": "Trwała mikstura skoku",
  "item.minecraft.lingering_potion.effect.levitation": "Trwała mikstura lewitacji",
  "item.minecraft.lingering_potion.effect.luck": "Trwała mikstura szczęścia",
  "item.minecraft.lingering_potion.effect.mundane": "Trwała mdła mikstura",
  "item.minecraft.lingering_potion.effect.night_vision": "Trwała mikstura noktowizji",
  "item.minecraft.lingering_potion.effect.oozing": "Trwała mikstura zaszlamienia",
  "item.minecraft.lingering_potion.effect.poison": "Trwała mikstura zatrucia",
  "item.minecraft.lingering_potion.effect.regeneration": "Trwała mikstura regeneracji",
  "item.minecraft.lingering_potion.effect.slow_falling": "Trwała mikstura powolnego opadania",
  "item.minecraft.lingering_potion.effect.slowness": "Trwała mikstura spowolnienia",
  "item.minecraft.lingering_potion.effect.strength": "Trwała mikstura siły",
  "item.minecraft.lingering_potion.effect.swiftness": "Trwała mikstura szybkości",
  "item.minecraft.lingering_potion.effect.thick": "Trwała gęsta mikstura",
  "item.minecraft.lingering_potion.effect.turtle_master": "Trwała mikstura żółwiego mistrza",
  "item.minecraft.lingering_potion.effect.water": "Trwała butelka wody",
  "item.minecraft.lingering_potion.effect.water_breathing": "Trwała mikstura oddychania pod wodą",
  "item.minecraft.lingering_potion.effect.weakness": "Trwała mikstura słabości",
  "item.minecraft.lingering_potion.effect.weaving": "Trwała mikstura przędzenia",
  "item.minecraft.lingering_potion.effect.wind_charged": "Trwała mikstura napowietrzenia",
  "item.minecraft.llama_spawn_egg": "Jajo przyzywające lamę",
  "item.minecraft.lodestone_compass": "Magnetytowy kompas",
  "item.minecraft.mace": "Buzdygan",
  "item.minecraft.magenta_bundle": "Purpurowa sakwa",
  "item.minecraft.magenta_dye": "Purpurowy barwnik",
  "item.minecraft.magenta_harness": "Purpurowa uprząż",
  "item.minecraft.magma_cream": "Magmowy krem",
  "item.minecraft.magma_cube_spawn_egg": "Jajo przyzywające kostkę magmy",
  "item.minecraft.mangrove_boat": "Namorzynowa łódka",
  "item.minecraft.mangrove_chest_boat": "Namorzynowa łódka ze skrzynią",
  "item.minecraft.map": "Pusta mapa",
  "item.minecraft.melon_seeds": "Nasiona arbuza",
  "item.minecraft.melon_slice": "Kawałek arbuza",
  "item.minecraft.milk_bucket": "Wiadro mleka",
  "item.minecraft.minecart": "Wagonik",
  "item.minecraft.miner_pottery_shard": "Odłamek ceramiki „Górnik”",
  "item.minecraft.miner_pottery_sherd": "Odłamek ceramiki „Górnik”",
  "item.minecraft.mojang_banner_pattern": "Wzór sztandaru",
  "item.minecraft.mojang_banner_pattern.desc": "Coś",
  "item.minecraft.mojang_banner_pattern.new": "Wzór sztandaru — coś",
  "item.minecraft.mooshroom_spawn_egg": "Jajo przyzywające mooshrooma",
  "item.minecraft.mourner_pottery_shard": "Odłamek ceramiki „Żałobnik”",
  "item.minecraft.mourner_pottery_sherd": "Odłamek ceramiki „Żałobnik”",
  "item.minecraft.mule_spawn_egg": "Jajo przyzywające muła",
  "item.minecraft.mushroom_stew": "Zupa grzybowa",
  "item.minecraft.music_disc_11": "Płyta muzyczna",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Płyta muzyczna",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Płyta muzyczna",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg — 5",
  "item.minecraft.music_disc_blocks": "Płyta muzyczna",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Płyta muzyczna",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Płyta muzyczna",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Płyta muzyczna",
  "item.minecraft.music_disc_creator.desc": "Lena Raine — Creator",
  "item.minecraft.music_disc_creator_music_box": "Płyta muzyczna",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine — Creator (Pozytywka)",
  "item.minecraft.music_disc_far": "Płyta muzyczna",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Płyta muzyczna",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Płyta muzyczna",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Płyta muzyczna",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Płyta muzyczna",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine — otherside",
  "item.minecraft.music_disc_pigstep": "Płyta muzyczna",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine — Pigstep",
  "item.minecraft.music_disc_precipice": "Płyta muzyczna",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof — Precipice",
  "item.minecraft.music_disc_relic": "Płyta muzyczna",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof — Relic",
  "item.minecraft.music_disc_stal": "Płyta muzyczna",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Płyta muzyczna",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Płyta muzyczna",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy — Tears",
  "item.minecraft.music_disc_wait": "Płyta muzyczna",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Płyta muzyczna",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Surowa baranina",
  "item.minecraft.name_tag": "Znacznik",
  "item.minecraft.nautilus_shell": "Muszla łodzika",
  "item.minecraft.nautilus_spawn_egg": "Jajo przyzywające łodzika",
  "item.minecraft.nether_brick": "Netherowa cegła",
  "item.minecraft.nether_star": "Netherowa gwiazda",
  "item.minecraft.nether_wart": "Netherowa brodawka",
  "item.minecraft.netherite_axe": "Netherytowa siekiera",
  "item.minecraft.netherite_boots": "Netherytowe buty",
  "item.minecraft.netherite_chestplate": "Netherytowy napierśnik",
  "item.minecraft.netherite_helmet": "Netherytowy hełm",
  "item.minecraft.netherite_hoe": "Netherytowa motyka",
  "item.minecraft.netherite_horse_armor": "Netherytowa zbroja końska",
  "item.minecraft.netherite_ingot": "Sztabka netherytu",
  "item.minecraft.netherite_leggings": "Netherytowe nogawice",
  "item.minecraft.netherite_nautilus_armor": "Netherytowa zbroja łodzika",
  "item.minecraft.netherite_pickaxe": "Netherytowy kilof",
  "item.minecraft.netherite_scrap": "Odłamek netherytu",
  "item.minecraft.netherite_shovel": "Netherytowa łopata",
  "item.minecraft.netherite_spear": "Netherytowa włócznia",
  "item.minecraft.netherite_sword": "Netherytowy miecz",
  "item.minecraft.netherite_upgrade_smithing_template": "Szablon kowalski",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherytowe ulepszenie",
  "item.minecraft.oak_boat": "Dębowa łódka",
  "item.minecraft.oak_chest_boat": "Dębowa łódka ze skrzynią",
  "item.minecraft.ocelot_spawn_egg": "Jajo przyzywające ocelota",
  "item.minecraft.ominous_bottle": "Złowieszcza butelka",
  "item.minecraft.ominous_trial_key": "Złowieszczy klucz próby",
  "item.minecraft.orange_bundle": "Pomarańczowa sakwa",
  "item.minecraft.orange_dye": "Pomarańczowy barwnik",
  "item.minecraft.orange_harness": "Pomarańczowa uprząż",
  "item.minecraft.painting": "Obraz",
  "item.minecraft.pale_oak_boat": "Bladodębowa łódka",
  "item.minecraft.pale_oak_chest_boat": "Bladodębowa łódka ze skrzynią",
  "item.minecraft.panda_spawn_egg": "Jajo przyzywające pandę",
  "item.minecraft.paper": "Papier",
  "item.minecraft.parched_spawn_egg": "Jajo przyzywające oschlaka",
  "item.minecraft.parrot_spawn_egg": "Jajo przyzywające papugę",
  "item.minecraft.phantom_membrane": "Błona fantoma",
  "item.minecraft.phantom_spawn_egg": "Jajo przyzywające fantoma",
  "item.minecraft.pig_spawn_egg": "Jajo przyzywające świnię",
  "item.minecraft.piglin_banner_pattern": "Wzór sztandaru",
  "item.minecraft.piglin_banner_pattern.desc": "Ryjek",
  "item.minecraft.piglin_banner_pattern.new": "Wzór sztandaru — ryjek",
  "item.minecraft.piglin_brute_spawn_egg": "Jajo przyzywające piglina okrutnika",
  "item.minecraft.piglin_spawn_egg": "Jajo przyzywające piglina",
  "item.minecraft.pillager_spawn_egg": "Jajo przyzywające rozbójnika",
  "item.minecraft.pink_bundle": "Różowa sakwa",
  "item.minecraft.pink_dye": "Różowy barwnik",
  "item.minecraft.pink_harness": "Różowa uprząż",
  "item.minecraft.pitcher_plant": "Dzbanecznik",
  "item.minecraft.pitcher_pod": "Strąk dzbanecznika",
  "item.minecraft.plenty_pottery_shard": "Odłamek ceramiki „Dostatek”",
  "item.minecraft.plenty_pottery_sherd": "Odłamek ceramiki „Dostatek”",
  "item.minecraft.poisonous_potato": "Trujący ziemniak",
  "item.minecraft.polar_bear_spawn_egg": "Jajo przyzywające niedźwiedzia polarnego",
  "item.minecraft.popped_chorus_fruit": "Prażony owoc refrenusu",
  "item.minecraft.porkchop": "Surowa wieprzowina",
  "item.minecraft.potato": "Ziemniak",
  "item.minecraft.potion": "Mikstura",
  "item.minecraft.potion.effect.awkward": "Klarowna mikstura",
  "item.minecraft.potion.effect.empty": "Niewykonalna mikstura",
  "item.minecraft.potion.effect.fire_resistance": "Mikstura ognioodporności",
  "item.minecraft.potion.effect.harming": "Mikstura krzywdy",
  "item.minecraft.potion.effect.healing": "Mikstura leczenia",
  "item.minecraft.potion.effect.infested": "Mikstura zarobaczenia",
  "item.minecraft.potion.effect.invisibility": "Mikstura niewidzialności",
  "item.minecraft.potion.effect.leaping": "Mikstura skoku",
  "item.minecraft.potion.effect.levitation": "Mikstura lewitacji",
  "item.minecraft.potion.effect.luck": "Mikstura szczęścia",
  "item.minecraft.potion.effect.mundane": "Mdła mikstura",
  "item.minecraft.potion.effect.night_vision": "Mikstura noktowizji",
  "item.minecraft.potion.effect.oozing": "Mikstura zaszlamienia",
  "item.minecraft.potion.effect.poison": "Mikstura zatrucia",
  "item.minecraft.potion.effect.regeneration": "Mikstura regeneracji",
  "item.minecraft.potion.effect.slow_falling": "Mikstura powolnego opadania",
  "item.minecraft.potion.effect.slowness": "Mikstura spowolnienia",
  "item.minecraft.potion.effect.strength": "Mikstura siły",
  "item.minecraft.potion.effect.swiftness": "Mikstura szybkości",
  "item.minecraft.potion.effect.thick": "Gęsta mikstura",
  "item.minecraft.potion.effect.turtle_master": "Mikstura żółwiego mistrza",
  "item.minecraft.potion.effect.water": "Butelka wody",
  "item.minecraft.potion.effect.water_breathing": "Mikstura oddychania pod wodą",
  "item.minecraft.potion.effect.weakness": "Mikstura słabości",
  "item.minecraft.potion.effect.weaving": "Mikstura przędzenia",
  "item.minecraft.potion.effect.wind_charged": "Mikstura napowietrzenia",
  "item.minecraft.pottery_shard_archer": "Odłamek ceramiki „Łucznik”",
  "item.minecraft.pottery_shard_arms_up": "Odłamek ceramiki „Ręce w górze”",
  "item.minecraft.pottery_shard_prize": "Odłamek ceramiki „Nagroda”",
  "item.minecraft.pottery_shard_skull": "Odłamek ceramiki „Czaszka”",
  "item.minecraft.powder_snow_bucket": "Wiadro sypkiego śniegu",
  "item.minecraft.prismarine_crystals": "Kryształy pryzmarynu",
  "item.minecraft.prismarine_shard": "Odłamek pryzmarynu",
  "item.minecraft.prize_pottery_shard": "Odłamek ceramiki „Nagroda”",
  "item.minecraft.prize_pottery_sherd": "Odłamek ceramiki „Nagroda”",
  "item.minecraft.pufferfish": "Rozdymka",
  "item.minecraft.pufferfish_bucket": "Wiadro z rozdymką",
  "item.minecraft.pufferfish_spawn_egg": "Jajo przyzywające rozdymkę",
  "item.minecraft.pumpkin_pie": "Placek dyniowy",
  "item.minecraft.pumpkin_seeds": "Nasiona dyni",
  "item.minecraft.purple_bundle": "Fioletowa sakwa",
  "item.minecraft.purple_dye": "Fioletowy barwnik",
  "item.minecraft.purple_harness": "Fioletowa uprząż",
  "item.minecraft.quartz": "Netherowy kwarc",
  "item.minecraft.rabbit": "Surowy królik",
  "item.minecraft.rabbit_foot": "Królicza łapka",
  "item.minecraft.rabbit_hide": "Królicza skóra",
  "item.minecraft.rabbit_spawn_egg": "Jajo przyzywające królika",
  "item.minecraft.rabbit_stew": "Potrawka z królika",
  "item.minecraft.raiser_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Zdobienie zbroi „Opiekun”",
  "item.minecraft.ravager_spawn_egg": "Jajo przyzywające dewastatora",
  "item.minecraft.raw_copper": "Ruda miedzi",
  "item.minecraft.raw_gold": "Surowe złoto",
  "item.minecraft.raw_iron": "Ruda żelaza",
  "item.minecraft.recovery_compass": "Kompas powrotny",
  "item.minecraft.red_bundle": "Czerwona sakwa",
  "item.minecraft.red_dye": "Czerwony barwnik",
  "item.minecraft.red_harness": "Czerwona uprząż",
  "item.minecraft.redstone": "Sproszkowany redstone",
  "item.minecraft.resin_brick": "Żywicowa cegła",
  "item.minecraft.resin_clump": "Gruda żywicy",
  "item.minecraft.rib_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Zdobienie zbroi „Żebra”",
  "item.minecraft.rotten_flesh": "Zgniłe mięso",
  "item.minecraft.saddle": "Siodło",
  "item.minecraft.salmon": "Surowy łosoś",
  "item.minecraft.salmon_bucket": "Wiadro z łososiem",
  "item.minecraft.salmon_spawn_egg": "Jajo przyzywające łososia",
  "item.minecraft.scrape_pottery_sherd": "Odłamek ceramiki „Skrobak”",
  "item.minecraft.scute": "Tarczka",
  "item.minecraft.sentry_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Zdobienie zbroi „Wartownik”",
  "item.minecraft.shaper_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Zdobienie zbroi „Rzeźbiarz”",
  "item.minecraft.sheaf_pottery_shard": "Odłamek ceramiki „Snop”",
  "item.minecraft.sheaf_pottery_sherd": "Odłamek ceramiki „Snop”",
  "item.minecraft.shears": "Nożyce",
  "item.minecraft.sheep_spawn_egg": "Jajo przyzywające owcę",
  "item.minecraft.shelter_pottery_shard": "Odłamek ceramiki „Ostoja”",
  "item.minecraft.shelter_pottery_sherd": "Odłamek ceramiki „Ostoja”",
  "item.minecraft.shield": "Tarcza",
  "item.minecraft.shield.black": "Czarna tarcza",
  "item.minecraft.shield.blue": "Niebieska tarcza",
  "item.minecraft.shield.brown": "Brązowa tarcza",
  "item.minecraft.shield.cyan": "Błękitna tarcza",
  "item.minecraft.shield.gray": "Szara tarcza",
  "item.minecraft.shield.green": "Zielona tarcza",
  "item.minecraft.shield.light_blue": "Jasnoniebieska tarcza",
  "item.minecraft.shield.light_gray": "Jasnoszara tarcza",
  "item.minecraft.shield.lime": "Jasnozielona tarcza",
  "item.minecraft.shield.magenta": "Purpurowa tarcza",
  "item.minecraft.shield.orange": "Pomarańczowa tarcza",
  "item.minecraft.shield.pink": "Różowa tarcza",
  "item.minecraft.shield.purple": "Fioletowa tarcza",
  "item.minecraft.shield.red": "Czerwona tarcza",
  "item.minecraft.shield.white": "Biała tarcza",
  "item.minecraft.shield.yellow": "Żółta tarcza",
  "item.minecraft.shulker_shell": "Skorupa shulkera",
  "item.minecraft.shulker_spawn_egg": "Jajo przyzywające shulkera",
  "item.minecraft.sign": "Tabliczka",
  "item.minecraft.silence_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Zdobienie zbroi „Cisza”",
  "item.minecraft.silverfish_spawn_egg": "Jajo przyzywające rybika cukrowego",
  "item.minecraft.skeleton_horse_spawn_egg": "Jajo przyzywające konia-szkieleta",
  "item.minecraft.skeleton_spawn_egg": "Jajo przyzywające szkieleta",
  "item.minecraft.skull_banner_pattern": "Wzór sztandaru",
  "item.minecraft.skull_banner_pattern.desc": "Wzór czaszki",
  "item.minecraft.skull_banner_pattern.new": "Wzór sztandaru — czaszka",
  "item.minecraft.skull_pottery_shard": "Odłamek ceramiki „Czaszka”",
  "item.minecraft.skull_pottery_sherd": "Odłamek ceramiki „Czaszka”",
  "item.minecraft.slime_ball": "Kula szlamu",
  "item.minecraft.slime_spawn_egg": "Jajo przyzywające szlama",
  "item.minecraft.smithing_template": "Szablon kowalski",
  "item.minecraft.smithing_template.applies_to": "Nakładany na:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Dodaj sztabkę lub minerał",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Zbroja",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Dodaj element zbroi",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Sztabki i kryształy",
  "item.minecraft.smithing_template.ingredients": "Składniki:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Dodaj sztabkę netherytu",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamentowe wyposażenie",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Dodaj diamentową zbroję, broń lub narzędzie",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Sztabka netherytu",
  "item.minecraft.smithing_template.upgrade": "Ulepszenie: ",
  "item.minecraft.sniffer_spawn_egg": "Jajo przyzywające niuchacza",
  "item.minecraft.snort_pottery_shard": "Odłamek ceramiki „Niuch”",
  "item.minecraft.snort_pottery_sherd": "Odłamek ceramiki „Niuch”",
  "item.minecraft.snout_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Zdobienie zbroi „Ryjek”",
  "item.minecraft.snow_golem_spawn_egg": "Jajo przyzywające śnieżnego golema",
  "item.minecraft.snowball": "Śnieżka",
  "item.minecraft.spectral_arrow": "Widmowa strzała",
  "item.minecraft.spider_eye": "Oko pająka",
  "item.minecraft.spider_spawn_egg": "Jajo przyzywające pająka",
  "item.minecraft.spire_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Zdobienie zbroi „Iglica”",
  "item.minecraft.splash_potion": "Mikstura miotana",
  "item.minecraft.splash_potion.effect.awkward": "Miotana klarowna mikstura",
  "item.minecraft.splash_potion.effect.empty": "Miotana niewykonalna mikstura",
  "item.minecraft.splash_potion.effect.fire_resistance": "Miotana mikstura ognioodporności",
  "item.minecraft.splash_potion.effect.harming": "Miotana mikstura krzywdy",
  "item.minecraft.splash_potion.effect.healing": "Miotana mikstura leczenia",
  "item.minecraft.splash_potion.effect.infested": "Miotana mikstura zarobaczenia",
  "item.minecraft.splash_potion.effect.invisibility": "Miotana mikstura niewidzialności",
  "item.minecraft.splash_potion.effect.leaping": "Miotana mikstura skoku",
  "item.minecraft.splash_potion.effect.levitation": "Miotana mikstura lewitacji",
  "item.minecraft.splash_potion.effect.luck": "Miotana mikstura szczęścia",
  "item.minecraft.splash_potion.effect.mundane": "Mdła mikstura miotana",
  "item.minecraft.splash_potion.effect.night_vision": "Miotana mikstura noktowizji",
  "item.minecraft.splash_potion.effect.oozing": "Miotana mikstura zaszlamienia",
  "item.minecraft.splash_potion.effect.poison": "Miotana mikstura zatrucia",
  "item.minecraft.splash_potion.effect.regeneration": "Miotana mikstura regeneracji",
  "item.minecraft.splash_potion.effect.slow_falling": "Miotana mikstura powolnego opadania",
  "item.minecraft.splash_potion.effect.slowness": "Miotana mikstura spowolnienia",
  "item.minecraft.splash_potion.effect.strength": "Miotana mikstura siły",
  "item.minecraft.splash_potion.effect.swiftness": "Miotana mikstura szybkości",
  "item.minecraft.splash_potion.effect.thick": "Gęsta mikstura miotana",
  "item.minecraft.splash_potion.effect.turtle_master": "Miotana mikstura żółwiego mistrza",
  "item.minecraft.splash_potion.effect.water": "Miotana butelka wody",
  "item.minecraft.splash_potion.effect.water_breathing": "Miotana mikstura oddychania pod wodą",
  "item.minecraft.splash_potion.effect.weakness": "Miotana mikstura słabości",
  "item.minecraft.splash_potion.effect.weaving": "Miotana mikstura przędzenia",
  "item.minecraft.splash_potion.effect.wind_charged": "Miotana mikstura napowietrzenia",
  "item.minecraft.spruce_boat": "Świerkowa łódka",
  "item.minecraft.spruce_chest_boat": "Świerkowa łódka ze skrzynią",
  "item.minecraft.spyglass": "Luneta",
  "item.minecraft.squid_spawn_egg": "Jajo przyzywające kałamarnicę",
  "item.minecraft.stick": "Patyk",
  "item.minecraft.stone_axe": "Kamienna siekiera",
  "item.minecraft.stone_hoe": "Kamienna motyka",
  "item.minecraft.stone_pickaxe": "Kamienny kilof",
  "item.minecraft.stone_shovel": "Kamienna łopata",
  "item.minecraft.stone_spear": "Kamienna włócznia",
  "item.minecraft.stone_sword": "Kamienny miecz",
  "item.minecraft.stray_spawn_egg": "Jajo przyzywające tułacza",
  "item.minecraft.strider_spawn_egg": "Jajo przyzywające magmołaza",
  "item.minecraft.string": "Nić",
  "item.minecraft.sugar": "Cukier",
  "item.minecraft.suspicious_stew": "Podejrzana potrawka",
  "item.minecraft.sweet_berries": "Słodkie jagody",
  "item.minecraft.tadpole_bucket": "Wiadro z kijanką",
  "item.minecraft.tadpole_spawn_egg": "Jajo przyzywające kijankę",
  "item.minecraft.tide_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Zdobienie zbroi „Fala”",
  "item.minecraft.tipped_arrow": "Strzała z miksturą",
  "item.minecraft.tipped_arrow.effect.awkward": "Strzała z miksturą",
  "item.minecraft.tipped_arrow.effect.empty": "Niewykonalna strzała z miksturą",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Strzała ognioodporności",
  "item.minecraft.tipped_arrow.effect.harming": "Strzała krzywdy",
  "item.minecraft.tipped_arrow.effect.healing": "Strzała leczenia",
  "item.minecraft.tipped_arrow.effect.infested": "Strzała zarobaczenia",
  "item.minecraft.tipped_arrow.effect.invisibility": "Strzała niewidzialności",
  "item.minecraft.tipped_arrow.effect.leaping": "Strzała skoku",
  "item.minecraft.tipped_arrow.effect.levitation": "Strzała lewitacji",
  "item.minecraft.tipped_arrow.effect.luck": "Strzała szczęścia",
  "item.minecraft.tipped_arrow.effect.mundane": "Strzała z miksturą",
  "item.minecraft.tipped_arrow.effect.night_vision": "Strzała noktowizji",
  "item.minecraft.tipped_arrow.effect.oozing": "Strzała zaszlamienia",
  "item.minecraft.tipped_arrow.effect.poison": "Strzała zatrucia",
  "item.minecraft.tipped_arrow.effect.regeneration": "Strzała regeneracji",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Strzała powolnego opadania",
  "item.minecraft.tipped_arrow.effect.slowness": "Strzała spowolnienia",
  "item.minecraft.tipped_arrow.effect.strength": "Strzała siły",
  "item.minecraft.tipped_arrow.effect.swiftness": "Strzała szybkości",
  "item.minecraft.tipped_arrow.effect.thick": "Strzała z miksturą",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Strzała żółwiego mistrza",
  "item.minecraft.tipped_arrow.effect.water": "Strzała chlapiąca",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Strzała oddychania pod wodą",
  "item.minecraft.tipped_arrow.effect.weakness": "Strzała słabości",
  "item.minecraft.tipped_arrow.effect.weaving": "Strzała przędzenia",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Strzała napowietrzenia",
  "item.minecraft.tnt_minecart": "Wagonik z TNT",
  "item.minecraft.torchflower_seeds": "Nasiona ognistego kwiatu",
  "item.minecraft.totem_of_undying": "Totem nieśmiertelności",
  "item.minecraft.trader_llama_spawn_egg": "Jajo przyzywające lamę handlarza",
  "item.minecraft.trial_key": "Klucz próby",
  "item.minecraft.trident": "Trójząb",
  "item.minecraft.tropical_fish": "Ryba tropikalna",
  "item.minecraft.tropical_fish_bucket": "Wiadro z tropikalną rybą",
  "item.minecraft.tropical_fish_spawn_egg": "Jajo przyzywające rybę tropikalną",
  "item.minecraft.turtle_helmet": "Żółwia skorupa",
  "item.minecraft.turtle_scute": "Tarczka żółwia",
  "item.minecraft.turtle_spawn_egg": "Jajo przyzywające żółwia",
  "item.minecraft.vex_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Zdobienie zbroi „Dręczyciel”",
  "item.minecraft.vex_spawn_egg": "Jajo przyzywające dręczyciela",
  "item.minecraft.villager_spawn_egg": "Jajo przyzywające osadnika",
  "item.minecraft.vindicator_spawn_egg": "Jajo przyzywające obrońcę",
  "item.minecraft.wandering_trader_spawn_egg": "Jajo przyzywające wędrownego handlarza",
  "item.minecraft.ward_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Zdobienie zbroi „Nadzorca”",
  "item.minecraft.warden_spawn_egg": "Jajo przyzywające nadzorcę",
  "item.minecraft.warped_fungus_on_a_stick": "Spaczony grzyb na patyku",
  "item.minecraft.water_bucket": "Wiadro wody",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Zdobienie zbroi „Włóczykij”",
  "item.minecraft.wheat": "Pszenica",
  "item.minecraft.wheat_seeds": "Nasiona pszenicy",
  "item.minecraft.white_bundle": "Biała sakwa",
  "item.minecraft.white_dye": "Biały barwnik",
  "item.minecraft.white_harness": "Biała uprząż",
  "item.minecraft.wild_armor_trim_smithing_template": "Szablon kowalski",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Zdobienie zbroi „Dzicz”",
  "item.minecraft.wind_charge": "Wietrzna kula",
  "item.minecraft.witch_spawn_egg": "Jajo przyzywające wiedźmę",
  "item.minecraft.wither_skeleton_spawn_egg": "Jajo przyzywające witherowego szkieleta",
  "item.minecraft.wither_spawn_egg": "Jajo przyzywające withera",
  "item.minecraft.wolf_armor": "Wilcza zbroja",
  "item.minecraft.wolf_spawn_egg": "Jajo przyzywające wilka",
  "item.minecraft.wooden_axe": "Drewniana siekiera",
  "item.minecraft.wooden_hoe": "Drewniana motyka",
  "item.minecraft.wooden_pickaxe": "Drewniany kilof",
  "item.minecraft.wooden_shovel": "Drewniana łopata",
  "item.minecraft.wooden_spear": "Drewniana włócznia",
  "item.minecraft.wooden_sword": "Drewniany miecz",
  "item.minecraft.writable_book": "Książka z piórem",
  "item.minecraft.written_book": "Zapisana książka",
  "item.minecraft.yellow_bundle": "Żółta sakwa",
  "item.minecraft.yellow_dye": "Żółty barwnik",
  "item.minecraft.yellow_harness": "Żółta uprząż",
  "item.minecraft.zoglin_spawn_egg": "Jajo przyzywające zoglina",
  "item.minecraft.zombie_horse_spawn_egg": "Jajo przyzywające konia-zombie",
  "item.minecraft.zombie_nautilus_spawn_egg": "Jajo przyzywające łodzika-zombie",
  "item.minecraft.zombie_spawn_egg": "Jajo przyzywające zombie",
  "item.minecraft.zombie_villager_spawn_egg": "Jajo przyzywające osadnika-zombie",
  "item.minecraft.zombified_piglin_spawn_egg": "Jajo przyzywające zzombifikowanego piglina"
}
export const pl_pl = items; 
